import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Currency = /*#__PURE__*/function (Currency) {
  Currency[Currency["USD"] = 0] = "USD";
  Currency[Currency["CAD"] = 1] = "CAD";
  Currency[Currency["EUR"] = 2] = "EUR";
  Currency[Currency["AUD"] = 3] = "AUD";
  Currency[Currency["GBP"] = 4] = "GBP";
  Currency[Currency["NZD"] = 5] = "NZD";
  Currency[Currency["ZAR"] = 6] = "ZAR";
  return Currency;
}(Currency || {});
var DurationPeriod = /*#__PURE__*/function (DurationPeriod) {
  DurationPeriod[DurationPeriod["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  DurationPeriod[DurationPeriod["MONTH"] = 1] = "MONTH";
  DurationPeriod[DurationPeriod["YEAR"] = 2] = "YEAR";
  DurationPeriod[DurationPeriod["DAY"] = 3] = "DAY";
  DurationPeriod[DurationPeriod["WEEK"] = 4] = "WEEK";
  return DurationPeriod;
}(DurationPeriod || {});
var RevenuePeriod = /*#__PURE__*/function (RevenuePeriod) {
  RevenuePeriod[RevenuePeriod["ONETIME"] = 0] = "ONETIME";
  RevenuePeriod[RevenuePeriod["DAILY"] = 1] = "DAILY";
  RevenuePeriod[RevenuePeriod["WEEKLY"] = 2] = "WEEKLY";
  RevenuePeriod[RevenuePeriod["BIWEEKLY"] = 3] = "BIWEEKLY";
  RevenuePeriod[RevenuePeriod["MONTHLY"] = 4] = "MONTHLY";
  RevenuePeriod[RevenuePeriod["YEARLY"] = 5] = "YEARLY";
  return RevenuePeriod;
}(RevenuePeriod || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ActivationStatus = /*#__PURE__*/function (ActivationStatus) {
  ActivationStatus[ActivationStatus["PENDING"] = 0] = "PENDING";
  ActivationStatus[ActivationStatus["ACTIVATED"] = 1] = "ACTIVATED";
  ActivationStatus[ActivationStatus["ERRORED"] = 2] = "ERRORED";
  ActivationStatus[ActivationStatus["ALREADY_ACTIVATED"] = 3] = "ALREADY_ACTIVATED";
  ActivationStatus[ActivationStatus["IGNORED_ERRORS"] = 4] = "IGNORED_ERRORS";
  ActivationStatus[ActivationStatus["CANCELED"] = 5] = "CANCELED";
  ActivationStatus[ActivationStatus["DEACTIVATED"] = 6] = "DEACTIVATED";
  ActivationStatus[ActivationStatus["UNKNOWN"] = 7] = "UNKNOWN";
  ActivationStatus[ActivationStatus["SCHEDULED"] = 8] = "SCHEDULED";
  ActivationStatus[ActivationStatus["UNSCHEDULED"] = 9] = "UNSCHEDULED";
  return ActivationStatus;
}(ActivationStatus || {});
var FieldType = /*#__PURE__*/function (FieldType) {
  FieldType[FieldType["NOT_SPECIFIED"] = 0] = "NOT_SPECIFIED";
  FieldType[FieldType["TEXT"] = 1] = "TEXT";
  FieldType[FieldType["TEXTAREA"] = 2] = "TEXTAREA";
  FieldType[FieldType["DROPDOWN"] = 3] = "DROPDOWN";
  FieldType[FieldType["CHECKBOX"] = 4] = "CHECKBOX";
  FieldType[FieldType["FILE"] = 5] = "FILE";
  FieldType[FieldType["VBCUSER"] = 6] = "VBCUSER";
  return FieldType;
}(FieldType || {});
var FulfillmentOrderStatus = /*#__PURE__*/function (FulfillmentOrderStatus) {
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_STATUS_UNSET"] = 0] = "FULFILLMENT_STATUS_UNSET";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_STATUS_DETAILS_NEEDED"] = 1] = "FULFILLMENT_STATUS_DETAILS_NEEDED";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_STATUS_IN_REVIEW"] = 2] = "FULFILLMENT_STATUS_IN_REVIEW";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_STATUS_IN_PROGRESS"] = 3] = "FULFILLMENT_STATUS_IN_PROGRESS";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_STATUS_COMPLETED"] = 4] = "FULFILLMENT_STATUS_COMPLETED";
  FulfillmentOrderStatus[FulfillmentOrderStatus["FULFILLMENT_STATUS_CANCELLED"] = 5] = "FULFILLMENT_STATUS_CANCELLED";
  return FulfillmentOrderStatus;
}(FulfillmentOrderStatus || {});
var Origin = /*#__PURE__*/function (Origin) {
  Origin[Origin["SSC"] = 0] = "SSC";
  Origin[Origin["VBC"] = 1] = "VBC";
  Origin[Origin["PC"] = 2] = "PC";
  Origin[Origin["IMPORT"] = 3] = "IMPORT";
  return Origin;
}(Origin || {});
var Source = /*#__PURE__*/function (Source) {
  Source[Source["SOURCE_INVALID"] = 0] = "SOURCE_INVALID";
  Source[Source["SOURCE_SYSTEM"] = 1] = "SOURCE_SYSTEM";
  Source[Source["SOURCE_SYSTEM_ADMIN"] = 2] = "SOURCE_SYSTEM_ADMIN";
  return Source;
}(Source || {});
var Status = /*#__PURE__*/function (Status) {
  Status[Status["SUBMITTED"] = 0] = "SUBMITTED";
  Status[Status["APPROVED"] = 1] = "APPROVED";
  Status[Status["DECLINED"] = 2] = "DECLINED";
  Status[Status["DRAFTED"] = 3] = "DRAFTED";
  Status[Status["FULFILLED"] = 4] = "FULFILLED";
  Status[Status["PROCESSING"] = 5] = "PROCESSING";
  Status[Status["ACTIVATION_ERRORS"] = 6] = "ACTIVATION_ERRORS";
  Status[Status["ARCHIVED"] = 7] = "ARCHIVED";
  Status[Status["SUBMITTED_FOR_CUSTOMER_APPROVAL"] = 8] = "SUBMITTED_FOR_CUSTOMER_APPROVAL";
  Status[Status["CANCELLATION_REQUESTED"] = 9] = "CANCELLATION_REQUESTED";
  Status[Status["CANCELLED"] = 10] = "CANCELLED";
  Status[Status["SCHEDULED_ACTIVATION"] = 11] = "SCHEDULED_ACTIVATION";
  Status[Status["AWAITING_PAYMENT"] = 12] = "AWAITING_PAYMENT";
  Status[Status["PROCESSING_PAYMENT"] = 13] = "PROCESSING_PAYMENT";
  Status[Status["RESUBMITTED"] = 14] = "RESUBMITTED";
  return Status;
}(Status || {});
var UserRole = /*#__PURE__*/function (UserRole) {
  UserRole[UserRole["USER_ROLE_UNSPECIFIED"] = 0] = "USER_ROLE_UNSPECIFIED";
  UserRole[UserRole["USER_ROLE_ADMIN"] = 1] = "USER_ROLE_ADMIN";
  UserRole[UserRole["USER_ROLE_SALESPERSON"] = 2] = "USER_ROLE_SALESPERSON";
  UserRole[UserRole["USER_ROLE_CLIENT"] = 3] = "USER_ROLE_CLIENT";
  return UserRole;
}(UserRole || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var SubscriptionLocation = /*#__PURE__*/function (SubscriptionLocation) {
  SubscriptionLocation[SubscriptionLocation["SUBSCRIPTION_LOCATION_NOT_USED"] = 0] = "SUBSCRIPTION_LOCATION_NOT_USED";
  SubscriptionLocation[SubscriptionLocation["SUBSCRIPTION_LOCATION_PARTNER_CENTER"] = 1] = "SUBSCRIPTION_LOCATION_PARTNER_CENTER";
  SubscriptionLocation[SubscriptionLocation["SUBSCRIPTION_LOCATION_SALES_CENTER"] = 2] = "SUBSCRIPTION_LOCATION_SALES_CENTER";
  SubscriptionLocation[SubscriptionLocation["SUBSCRIPTION_LOCATION_BUSINESS_CENTER"] = 3] = "SUBSCRIPTION_LOCATION_BUSINESS_CENTER";
  return SubscriptionLocation;
}(SubscriptionLocation || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AuxiliaryDataFieldType = /*#__PURE__*/function (AuxiliaryDataFieldType) {
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_INVALID"] = 0] = "AUXILIARY_DATA_FIELD_TYPE_INVALID";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_STRING"] = 1] = "AUXILIARY_DATA_FIELD_TYPE_STRING";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_INTEGER"] = 2] = "AUXILIARY_DATA_FIELD_TYPE_INTEGER";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_DATE"] = 3] = "AUXILIARY_DATA_FIELD_TYPE_DATE";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_DROPDOWN"] = 4] = "AUXILIARY_DATA_FIELD_TYPE_DROPDOWN";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_CURRENCY"] = 5] = "AUXILIARY_DATA_FIELD_TYPE_CURRENCY";
  return AuxiliaryDataFieldType;
}(AuxiliaryDataFieldType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ValidationErrorCodes = /*#__PURE__*/function (ValidationErrorCodes) {
  ValidationErrorCodes[ValidationErrorCodes["UNKNOWN_ERROR_CODE"] = 0] = "UNKNOWN_ERROR_CODE";
  ValidationErrorCodes[ValidationErrorCodes["ALREADY_ACTIVE"] = 1] = "ALREADY_ACTIVE";
  ValidationErrorCodes[ValidationErrorCodes["INVALID_BILLING_TERMS"] = 2] = "INVALID_BILLING_TERMS";
  return ValidationErrorCodes;
}(ValidationErrorCodes || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var InitiateOrderExportRequestDataFormatOption = /*#__PURE__*/function (InitiateOrderExportRequestDataFormatOption) {
  InitiateOrderExportRequestDataFormatOption[InitiateOrderExportRequestDataFormatOption["ORDERS_PER_ROW"] = 0] = "ORDERS_PER_ROW";
  InitiateOrderExportRequestDataFormatOption[InitiateOrderExportRequestDataFormatOption["PRODUCTS_PER_ROW"] = 1] = "PRODUCTS_PER_ROW";
  InitiateOrderExportRequestDataFormatOption[InitiateOrderExportRequestDataFormatOption["ORDERS_PER_ROW_SALES"] = 2] = "ORDERS_PER_ROW_SALES";
  InitiateOrderExportRequestDataFormatOption[InitiateOrderExportRequestDataFormatOption["PRODUCTS_PER_ROW_SALES"] = 3] = "PRODUCTS_PER_ROW_SALES";
  InitiateOrderExportRequestDataFormatOption[InitiateOrderExportRequestDataFormatOption["ORDERS_PER_ROW_BUYER"] = 4] = "ORDERS_PER_ROW_BUYER";
  InitiateOrderExportRequestDataFormatOption[InitiateOrderExportRequestDataFormatOption["PRODUCTS_PER_ROW_BUYER"] = 5] = "PRODUCTS_PER_ROW_BUYER";
  return InitiateOrderExportRequestDataFormatOption;
}(InitiateOrderExportRequestDataFormatOption || {});
var ListSalesOrderRequestSortDirection = /*#__PURE__*/function (ListSalesOrderRequestSortDirection) {
  ListSalesOrderRequestSortDirection[ListSalesOrderRequestSortDirection["ASCENDING"] = 0] = "ASCENDING";
  ListSalesOrderRequestSortDirection[ListSalesOrderRequestSortDirection["DESCENDING"] = 1] = "DESCENDING";
  return ListSalesOrderRequestSortDirection;
}(ListSalesOrderRequestSortDirection || {});
var ListCustomerSalesOrderRequestSortDirection = /*#__PURE__*/function (ListCustomerSalesOrderRequestSortDirection) {
  ListCustomerSalesOrderRequestSortDirection[ListCustomerSalesOrderRequestSortDirection["ASCENDING"] = 0] = "ASCENDING";
  ListCustomerSalesOrderRequestSortDirection[ListCustomerSalesOrderRequestSortDirection["DESCENDING"] = 1] = "DESCENDING";
  return ListCustomerSalesOrderRequestSortDirection;
}(ListCustomerSalesOrderRequestSortDirection || {});
var InitiateOrderExportRequestSortDirection = /*#__PURE__*/function (InitiateOrderExportRequestSortDirection) {
  InitiateOrderExportRequestSortDirection[InitiateOrderExportRequestSortDirection["ASCENDING"] = 0] = "ASCENDING";
  InitiateOrderExportRequestSortDirection[InitiateOrderExportRequestSortDirection["DESCENDING"] = 1] = "DESCENDING";
  return InitiateOrderExportRequestSortDirection;
}(InitiateOrderExportRequestSortDirection || {});
var ListCustomerSalesOrderRequestSortField = /*#__PURE__*/function (ListCustomerSalesOrderRequestSortField) {
  ListCustomerSalesOrderRequestSortField[ListCustomerSalesOrderRequestSortField["REQUESTED_ACTIVATION"] = 0] = "REQUESTED_ACTIVATION";
  ListCustomerSalesOrderRequestSortField[ListCustomerSalesOrderRequestSortField["CREATED"] = 1] = "CREATED";
  ListCustomerSalesOrderRequestSortField[ListCustomerSalesOrderRequestSortField["STATUS"] = 2] = "STATUS";
  ListCustomerSalesOrderRequestSortField[ListCustomerSalesOrderRequestSortField["EXPIRY_DATE"] = 3] = "EXPIRY_DATE";
  return ListCustomerSalesOrderRequestSortField;
}(ListCustomerSalesOrderRequestSortField || {});
var InitiateOrderExportRequestSortField = /*#__PURE__*/function (InitiateOrderExportRequestSortField) {
  InitiateOrderExportRequestSortField[InitiateOrderExportRequestSortField["REQUESTED_ACTIVATION"] = 0] = "REQUESTED_ACTIVATION";
  InitiateOrderExportRequestSortField[InitiateOrderExportRequestSortField["CREATED"] = 1] = "CREATED";
  InitiateOrderExportRequestSortField[InitiateOrderExportRequestSortField["STATUS"] = 2] = "STATUS";
  InitiateOrderExportRequestSortField[InitiateOrderExportRequestSortField["EXPIRY_DATE"] = 3] = "EXPIRY_DATE";
  return InitiateOrderExportRequestSortField;
}(InitiateOrderExportRequestSortField || {});
var ListSalesOrderRequestSortField = /*#__PURE__*/function (ListSalesOrderRequestSortField) {
  ListSalesOrderRequestSortField[ListSalesOrderRequestSortField["REQUESTED_ACTIVATION"] = 0] = "REQUESTED_ACTIVATION";
  ListSalesOrderRequestSortField[ListSalesOrderRequestSortField["CREATED"] = 1] = "CREATED";
  ListSalesOrderRequestSortField[ListSalesOrderRequestSortField["STATUS"] = 2] = "STATUS";
  ListSalesOrderRequestSortField[ListSalesOrderRequestSortField["EXPIRY_DATE"] = 3] = "EXPIRY_DATE";
  return ListSalesOrderRequestSortField;
}(ListSalesOrderRequestSortField || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ContentType = /*#__PURE__*/function (ContentType) {
  ContentType[ContentType["CONTENT_TYPE_TEXT_PLAIN"] = 0] = "CONTENT_TYPE_TEXT_PLAIN";
  ContentType[ContentType["CONTENT_TYPE_TEXT_HTML"] = 1] = "CONTENT_TYPE_TEXT_HTML";
  return ContentType;
}(ContentType || {});
var DocumentEventType = /*#__PURE__*/function (DocumentEventType) {
  DocumentEventType[DocumentEventType["DOCUMENT_EVENT_TYPE_INVALID"] = 0] = "DOCUMENT_EVENT_TYPE_INVALID";
  DocumentEventType[DocumentEventType["DOCUMENT_EVENT_TYPE_SENT_BY_EMAIL"] = 1] = "DOCUMENT_EVENT_TYPE_SENT_BY_EMAIL";
  DocumentEventType[DocumentEventType["DOCUMENT_EVENT_TYPE_VIEWED_BY_RECIPIENT"] = 2] = "DOCUMENT_EVENT_TYPE_VIEWED_BY_RECIPIENT";
  DocumentEventType[DocumentEventType["DOCUMENT_EVENT_TYPE_FEEDBACK_FROM_RECIPIENT"] = 3] = "DOCUMENT_EVENT_TYPE_FEEDBACK_FROM_RECIPIENT";
  DocumentEventType[DocumentEventType["DOCUMENT_EVENT_TYPE_APPROVED_BY_RECIPIENT"] = 4] = "DOCUMENT_EVENT_TYPE_APPROVED_BY_RECIPIENT";
  DocumentEventType[DocumentEventType["DOCUMENT_EVENT_TYPE_INTERNAL_REVIEW_REQUESTED"] = 5] = "DOCUMENT_EVENT_TYPE_INTERNAL_REVIEW_REQUESTED";
  DocumentEventType[DocumentEventType["DOCUMENT_EVENT_TYPE_COMMENT_FROM_INTERNAL_USER"] = 6] = "DOCUMENT_EVENT_TYPE_COMMENT_FROM_INTERNAL_USER";
  DocumentEventType[DocumentEventType["DOCUMENT_EVENT_TYPE_REVIEWED_BY_INTERNAL_USER"] = 7] = "DOCUMENT_EVENT_TYPE_REVIEWED_BY_INTERNAL_USER";
  DocumentEventType[DocumentEventType["DOCUMENT_EVENT_TYPE_UNLOCK_DOCUMENT"] = 8] = "DOCUMENT_EVENT_TYPE_UNLOCK_DOCUMENT";
  return DocumentEventType;
}(DocumentEventType || {});
var DocumentShareType = /*#__PURE__*/function (DocumentShareType) {
  DocumentShareType[DocumentShareType["DOCUMENT_SHARE_TYPE_INVALID"] = 0] = "DOCUMENT_SHARE_TYPE_INVALID";
  DocumentShareType[DocumentShareType["DOCUMENT_SHARE_TYPE_GLOBAL"] = 1] = "DOCUMENT_SHARE_TYPE_GLOBAL";
  DocumentShareType[DocumentShareType["DOCUMENT_SHARE_TYPE_ORGANIZATION"] = 2] = "DOCUMENT_SHARE_TYPE_ORGANIZATION";
  return DocumentShareType;
}(DocumentShareType || {});
var DocumentStatus = /*#__PURE__*/function (DocumentStatus) {
  DocumentStatus[DocumentStatus["DOCUMENT_STATUS_INVALID"] = 0] = "DOCUMENT_STATUS_INVALID";
  DocumentStatus[DocumentStatus["DOCUMENT_STATUS_SENT"] = 1] = "DOCUMENT_STATUS_SENT";
  DocumentStatus[DocumentStatus["DOCUMENT_STATUS_VIEWED_BY_RECIPIENT"] = 2] = "DOCUMENT_STATUS_VIEWED_BY_RECIPIENT";
  DocumentStatus[DocumentStatus["DOCUMENT_STATUS_FEEDBACK_FROM_RECIPIENT"] = 3] = "DOCUMENT_STATUS_FEEDBACK_FROM_RECIPIENT";
  DocumentStatus[DocumentStatus["DOCUMENT_STATUS_APPROVED_BY_RECIPIENT"] = 4] = "DOCUMENT_STATUS_APPROVED_BY_RECIPIENT";
  DocumentStatus[DocumentStatus["DOCUMENT_STATUS_ARCHIVED"] = 5] = "DOCUMENT_STATUS_ARCHIVED";
  DocumentStatus[DocumentStatus["DOCUMENT_STATUS_DELETED"] = 6] = "DOCUMENT_STATUS_DELETED";
  DocumentStatus[DocumentStatus["DOCUMENT_STATUS_PENDING_REVIEW"] = 7] = "DOCUMENT_STATUS_PENDING_REVIEW";
  DocumentStatus[DocumentStatus["DOCUMENT_STATUS_REVIEWED"] = 8] = "DOCUMENT_STATUS_REVIEWED";
  DocumentStatus[DocumentStatus["DOCUMENT_STATUS_DRAFT"] = 50] = "DOCUMENT_STATUS_DRAFT";
  return DocumentStatus;
}(DocumentStatus || {});
var DocumentType = /*#__PURE__*/function (DocumentType) {
  DocumentType[DocumentType["DOCUMENT_TYPE_INVALID"] = 0] = "DOCUMENT_TYPE_INVALID";
  DocumentType[DocumentType["DOCUMENT_TYPE_PROPOSAL"] = 1] = "DOCUMENT_TYPE_PROPOSAL";
  DocumentType[DocumentType["DOCUMENT_TYPE_PROPOSAL_TEMPLATE"] = 2] = "DOCUMENT_TYPE_PROPOSAL_TEMPLATE";
  DocumentType[DocumentType["DOCUMENT_TYPE_PAGE_TEMPLATE"] = 3] = "DOCUMENT_TYPE_PAGE_TEMPLATE";
  DocumentType[DocumentType["DOCUMENT_TYPE_WIDGET_TEMPLATE"] = 4] = "DOCUMENT_TYPE_WIDGET_TEMPLATE";
  return DocumentType;
}(DocumentType || {});
var OrganizationType = /*#__PURE__*/function (OrganizationType) {
  OrganizationType[OrganizationType["ORGANIZATION_TYPE_INVALID"] = 0] = "ORGANIZATION_TYPE_INVALID";
  OrganizationType[OrganizationType["ORGANIZATION_TYPE_PARTNER"] = 1] = "ORGANIZATION_TYPE_PARTNER";
  OrganizationType[OrganizationType["ORGANIZATION_TYPE_SMB"] = 2] = "ORGANIZATION_TYPE_SMB";
  return OrganizationType;
}(OrganizationType || {});
var Orientation = /*#__PURE__*/function (Orientation) {
  Orientation[Orientation["ORIENTATION_PORTRAIT"] = 0] = "ORIENTATION_PORTRAIT";
  Orientation[Orientation["ORIENTATION_LANDSCAPE"] = 1] = "ORIENTATION_LANDSCAPE";
  return Orientation;
}(Orientation || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$e(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class LineItemAppKey {
  static fromProto(proto) {
    let m = new LineItemAppKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.packageInstanceId !== 'undefined') {
      toReturn['packageInstanceId'] = this.packageInstanceId;
    }
    return toReturn;
  }
}
class BillingPeriod {
  static fromProto(proto) {
    let m = new BillingPeriod();
    m = Object.assign(m, proto);
    if (proto.startDate) {
      m.startDate = new Date(proto.startDate);
    }
    if (proto.endDate) {
      m.endDate = new Date(proto.endDate);
    }
    if (proto.duration) {
      m.duration = Duration.fromProto(proto.duration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.startDate !== 'undefined' && this.startDate !== null) {
      toReturn['startDate'] = 'toApiJson' in this.startDate ? this.startDate.toApiJson() : this.startDate;
    }
    if (typeof this.endDate !== 'undefined' && this.endDate !== null) {
      toReturn['endDate'] = 'toApiJson' in this.endDate ? this.endDate.toApiJson() : this.endDate;
    }
    if (typeof this.duration !== 'undefined' && this.duration !== null) {
      toReturn['duration'] = 'toApiJson' in this.duration ? this.duration.toApiJson() : this.duration;
    }
    return toReturn;
  }
}
class Cost {
  static fromProto(proto) {
    let m = new Cost();
    m = Object.assign(m, proto);
    if (proto.customPrice) {
      m.customPrice = parseInt(proto.customPrice, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customPrice !== 'undefined') {
      toReturn['customPrice'] = this.customPrice;
    }
    return toReturn;
  }
}
class CustomPriceMapping {
  static fromProto(proto) {
    let m = new CustomPriceMapping();
    m = Object.assign(m, proto);
    if (proto.customPrice) {
      m.customPrice = parseInt(proto.customPrice, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.customPrice !== 'undefined') {
      toReturn['customPrice'] = this.customPrice;
    }
    return toReturn;
  }
}
class Duration {
  static fromProto(proto) {
    let m = new Duration();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.duration) {
      m.duration = enumStringToValue$e(DurationPeriod, proto.duration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    return toReturn;
  }
}
class LineItem {
  static fromProto(proto) {
    let m = new LineItem();
    m = Object.assign(m, proto);
    if (proto.appKey) {
      m.appKey = LineItemAppKey.fromProto(proto.appKey);
    }
    if (proto.currency) {
      m.currency = enumStringToValue$e(Currency, proto.currency);
    }
    if (proto.initialRevenue) {
      m.initialRevenue = Revenue.fromProto(proto.initialRevenue);
    }
    if (proto.currentRevenue) {
      m.currentRevenue = Revenue.fromProto(proto.currentRevenue);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    if (proto.cost) {
      m.cost = Cost.fromProto(proto.cost);
    }
    if (proto.customPrices) {
      m.customPrices = proto.customPrices.map(CustomPriceMapping.fromProto);
    }
    if (proto.billingPeriod) {
      m.billingPeriod = BillingPeriod.fromProto(proto.billingPeriod);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKey !== 'undefined' && this.appKey !== null) {
      toReturn['appKey'] = 'toApiJson' in this.appKey ? this.appKey.toApiJson() : this.appKey;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.initialRevenue !== 'undefined' && this.initialRevenue !== null) {
      toReturn['initialRevenue'] = 'toApiJson' in this.initialRevenue ? this.initialRevenue.toApiJson() : this.initialRevenue;
    }
    if (typeof this.currentRevenue !== 'undefined' && this.currentRevenue !== null) {
      toReturn['currentRevenue'] = 'toApiJson' in this.currentRevenue ? this.currentRevenue.toApiJson() : this.currentRevenue;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.cost !== 'undefined' && this.cost !== null) {
      toReturn['cost'] = 'toApiJson' in this.cost ? this.cost.toApiJson() : this.cost;
    }
    if (typeof this.customPrices !== 'undefined' && this.customPrices !== null) {
      toReturn['customPrices'] = 'toApiJson' in this.customPrices ? this.customPrices.toApiJson() : this.customPrices;
    }
    if (typeof this.billingPeriod !== 'undefined' && this.billingPeriod !== null) {
      toReturn['billingPeriod'] = 'toApiJson' in this.billingPeriod ? this.billingPeriod.toApiJson() : this.billingPeriod;
    }
    if (typeof this.autoBillable !== 'undefined') {
      toReturn['autoBillable'] = this.autoBillable;
    }
    if (typeof this.nonBillable !== 'undefined') {
      toReturn['nonBillable'] = this.nonBillable;
    }
    if (typeof this.taxRateIds !== 'undefined') {
      toReturn['taxRateIds'] = this.taxRateIds;
    }
    return toReturn;
  }
}
class Revenue {
  static fromProto(proto) {
    let m = new Revenue();
    m = Object.assign(m, proto);
    if (proto.revenueComponents) {
      m.revenueComponents = proto.revenueComponents.map(RevenueComponent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.revenueComponents !== 'undefined' && this.revenueComponents !== null) {
      toReturn['revenueComponents'] = 'toApiJson' in this.revenueComponents ? this.revenueComponents.toApiJson() : this.revenueComponents;
    }
    return toReturn;
  }
}
class RevenueComponent {
  static fromProto(proto) {
    let m = new RevenueComponent();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    if (proto.period) {
      m.period = enumStringToValue$e(RevenuePeriod, proto.period);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.period !== 'undefined') {
      toReturn['period'] = this.period;
    }
    if (typeof this.isStartingRevenue !== 'undefined') {
      toReturn['isStartingRevenue'] = this.isStartingRevenue;
    }
    return toReturn;
  }
}
function enumStringToValue$d(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class TaxOptions {
  static fromProto(proto) {
    let m = new TaxOptions();
    m = Object.assign(m, proto);
    if (proto.initialAmount) {
      m.initialAmount = parseInt(proto.initialAmount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.percentageMultiplier !== 'undefined') {
      toReturn['percentageMultiplier'] = this.percentageMultiplier;
    }
    if (typeof this.initialAmount !== 'undefined') {
      toReturn['initialAmount'] = this.initialAmount;
    }
    if (typeof this.taxRateId !== 'undefined') {
      toReturn['taxRateId'] = this.taxRateId;
    }
    return toReturn;
  }
}
function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddonActivation {
  static fromProto(proto) {
    let m = new AddonActivation();
    m = Object.assign(m, proto);
    if (proto.activationStatus) {
      m.activationStatus = enumStringToValue$c(ActivationStatus, proto.activationStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.activationStatus !== 'undefined') {
      toReturn['activationStatus'] = this.activationStatus;
    }
    return toReturn;
  }
}
class AddonKey {
  static fromProto(proto) {
    let m = new AddonKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class Agreement {
  static fromProto(proto) {
    let m = new Agreement();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.term !== 'undefined') {
      toReturn['term'] = this.term;
    }
    if (typeof this.agreed !== 'undefined') {
      toReturn['agreed'] = this.agreed;
    }
    return toReturn;
  }
}
class Attachment {
  static fromProto(proto) {
    let m = new Attachment();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class Business {
  static fromProto(proto) {
    let m = new Business();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.deleted !== 'undefined') {
      toReturn['deleted'] = this.deleted;
    }
    return toReturn;
  }
}
class CommonField {
  static fromProto(proto) {
    let m = new CommonField();
    m = Object.assign(m, proto);
    if (proto.field) {
      m.field = Field.fromProto(proto.field);
    }
    if (proto.addonKeys) {
      m.addonKeys = proto.addonKeys.map(AddonKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.field !== 'undefined' && this.field !== null) {
      toReturn['field'] = 'toApiJson' in this.field ? this.field.toApiJson() : this.field;
    }
    if (typeof this.productIds !== 'undefined') {
      toReturn['productIds'] = this.productIds;
    }
    if (typeof this.addonKeys !== 'undefined' && this.addonKeys !== null) {
      toReturn['addonKeys'] = 'toApiJson' in this.addonKeys ? this.addonKeys.toApiJson() : this.addonKeys;
    }
    return toReturn;
  }
}
class CustomField {
  static fromProto(proto) {
    let m = new CustomField();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(Field.fromProto);
    }
    if (proto.addonKey) {
      m.addonKey = AddonKey.fromProto(proto.addonKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.addonKey !== 'undefined' && this.addonKey !== null) {
      toReturn['addonKey'] = 'toApiJson' in this.addonKey ? this.addonKey.toApiJson() : this.addonKey;
    }
    return toReturn;
  }
}
class CustomerRecipient {
  static fromProto(proto) {
    let m = new CustomerRecipient();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    return toReturn;
  }
}
class DeclinedReason {
  static fromProto(proto) {
    let m = new DeclinedReason();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    return toReturn;
  }
}
class Field {
  static fromProto(proto) {
    let m = new Field();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue$c(FieldType, proto.fieldType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.answer !== 'undefined') {
      toReturn['answer'] = this.answer;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.prefix !== 'undefined') {
      toReturn['prefix'] = this.prefix;
    }
    if (typeof this.suffix !== 'undefined') {
      toReturn['suffix'] = this.suffix;
    }
    if (typeof this.regexValidator !== 'undefined') {
      toReturn['regexValidator'] = this.regexValidator;
    }
    if (typeof this.regexErrorMessage !== 'undefined') {
      toReturn['regexErrorMessage'] = this.regexErrorMessage;
    }
    return toReturn;
  }
}
class GetOrderRecipientDetailsRequest {
  static fromProto(proto) {
    let m = new GetOrderRecipientDetailsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class GetOrderRecipientDetailsResponse {
  static fromProto(proto) {
    let m = new GetOrderRecipientDetailsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class Order {
  static fromProto(proto) {
    let m = new Order();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$c(Status, proto.status);
    }
    if (proto.requestedActivation) {
      m.requestedActivation = new Date(proto.requestedActivation);
    }
    if (proto.packages) {
      m.packages = proto.packages.map(Package.fromProto);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(CommonField.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.productActivations) {
      m.productActivations = proto.productActivations.map(ProductActivation.fromProto);
    }
    if (proto.addonActivations) {
      m.addonActivations = proto.addonActivations.map(AddonActivation.fromProto);
    }
    if (proto.statusHistory) {
      m.statusHistory = proto.statusHistory.map(StatusHistoryItem.fromProto);
    }
    if (proto.products) {
      m.products = proto.products.map(Product.fromProto);
    }
    if (proto.origin) {
      m.origin = enumStringToValue$c(Origin, proto.origin);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(Field.fromProto);
    }
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(LineItem.fromProto);
    }
    if (proto.contractDuration) {
      m.contractDuration = Duration.fromProto(proto.contractDuration);
    }
    if (proto.taxOptions) {
      m.taxOptions = proto.taxOptions.map(TaxOptions.fromProto);
    }
    if (proto.agreements) {
      m.agreements = proto.agreements.map(Agreement.fromProto);
    }
    if (proto.expiryDate) {
      m.expiryDate = new Date(proto.expiryDate);
    }
    if (proto.offerExpiry) {
      m.offerExpiry = new Date(proto.offerExpiry);
    }
    if (proto.business) {
      m.business = Business.fromProto(proto.business);
    }
    if (proto.salesperson) {
      m.salesperson = Salesperson.fromProto(proto.salesperson);
    }
    if (proto.leasedToAutomations) {
      m.leasedToAutomations = new Date(proto.leasedToAutomations);
    }
    if (proto.fulfillmentStatus) {
      m.fulfillmentStatus = enumStringToValue$c(FulfillmentOrderStatus, proto.fulfillmentStatus);
    }
    if (proto.customerAttachments) {
      m.customerAttachments = proto.customerAttachments.map(Attachment.fromProto);
    }
    if (proto.customerRecipient) {
      m.customerRecipient = CustomerRecipient.fromProto(proto.customerRecipient);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.opportunityIds !== 'undefined') {
      toReturn['opportunityIds'] = this.opportunityIds;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.requestedActivation !== 'undefined' && this.requestedActivation !== null) {
      toReturn['requestedActivation'] = 'toApiJson' in this.requestedActivation ? this.requestedActivation.toApiJson() : this.requestedActivation;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.packages !== 'undefined' && this.packages !== null) {
      toReturn['packages'] = 'toApiJson' in this.packages ? this.packages.toApiJson() : this.packages;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.productActivations !== 'undefined' && this.productActivations !== null) {
      toReturn['productActivations'] = 'toApiJson' in this.productActivations ? this.productActivations.toApiJson() : this.productActivations;
    }
    if (typeof this.addonActivations !== 'undefined' && this.addonActivations !== null) {
      toReturn['addonActivations'] = 'toApiJson' in this.addonActivations ? this.addonActivations.toApiJson() : this.addonActivations;
    }
    if (typeof this.statusHistory !== 'undefined' && this.statusHistory !== null) {
      toReturn['statusHistory'] = 'toApiJson' in this.statusHistory ? this.statusHistory.toApiJson() : this.statusHistory;
    }
    if (typeof this.declinedReason !== 'undefined') {
      toReturn['declinedReason'] = this.declinedReason;
    }
    if (typeof this.products !== 'undefined' && this.products !== null) {
      toReturn['products'] = 'toApiJson' in this.products ? this.products.toApiJson() : this.products;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    if (typeof this.contractDuration !== 'undefined' && this.contractDuration !== null) {
      toReturn['contractDuration'] = 'toApiJson' in this.contractDuration ? this.contractDuration.toApiJson() : this.contractDuration;
    }
    if (typeof this.taxOptions !== 'undefined' && this.taxOptions !== null) {
      toReturn['taxOptions'] = 'toApiJson' in this.taxOptions ? this.taxOptions.toApiJson() : this.taxOptions;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.agreements !== 'undefined' && this.agreements !== null) {
      toReturn['agreements'] = 'toApiJson' in this.agreements ? this.agreements.toApiJson() : this.agreements;
    }
    if (typeof this.expiryDate !== 'undefined' && this.expiryDate !== null) {
      toReturn['expiryDate'] = 'toApiJson' in this.expiryDate ? this.expiryDate.toApiJson() : this.expiryDate;
    }
    if (typeof this.paymentMethodToken !== 'undefined') {
      toReturn['paymentMethodToken'] = this.paymentMethodToken;
    }
    if (typeof this.customerNotes !== 'undefined') {
      toReturn['customerNotes'] = this.customerNotes;
    }
    if (typeof this.offerExpiry !== 'undefined' && this.offerExpiry !== null) {
      toReturn['offerExpiry'] = 'toApiJson' in this.offerExpiry ? this.offerExpiry.toApiJson() : this.offerExpiry;
    }
    if (typeof this.quoteId !== 'undefined') {
      toReturn['quoteId'] = this.quoteId;
    }
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    if (typeof this.salesperson !== 'undefined' && this.salesperson !== null) {
      toReturn['salesperson'] = 'toApiJson' in this.salesperson ? this.salesperson.toApiJson() : this.salesperson;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.leasedToAutomations !== 'undefined' && this.leasedToAutomations !== null) {
      toReturn['leasedToAutomations'] = 'toApiJson' in this.leasedToAutomations ? this.leasedToAutomations.toApiJson() : this.leasedToAutomations;
    }
    if (typeof this.fulfillmentStatus !== 'undefined') {
      toReturn['fulfillmentStatus'] = this.fulfillmentStatus;
    }
    if (typeof this.hasFulfillment !== 'undefined') {
      toReturn['hasFulfillment'] = this.hasFulfillment;
    }
    if (typeof this.orderIsSmbPayable !== 'undefined') {
      toReturn['orderIsSmbPayable'] = this.orderIsSmbPayable;
    }
    if (typeof this.enforceContractTerm !== 'undefined') {
      toReturn['enforceContractTerm'] = this.enforceContractTerm;
    }
    if (typeof this.customerAttachments !== 'undefined' && this.customerAttachments !== null) {
      toReturn['customerAttachments'] = 'toApiJson' in this.customerAttachments ? this.customerAttachments.toApiJson() : this.customerAttachments;
    }
    if (typeof this.customerRecipient !== 'undefined' && this.customerRecipient !== null) {
      toReturn['customerRecipient'] = 'toApiJson' in this.customerRecipient ? this.customerRecipient.toApiJson() : this.customerRecipient;
    }
    return toReturn;
  }
}
class Package {
  static fromProto(proto) {
    let m = new Package();
    m = Object.assign(m, proto);
    if (proto.currency) {
      m.currency = enumStringToValue$c(Currency, proto.currency);
    }
    if (proto.revenue) {
      m.revenue = Revenue.fromProto(proto.revenue);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    if (proto.addonKeys) {
      m.addonKeys = proto.addonKeys.map(AddonKey.fromProto);
    }
    if (proto.customPrices) {
      m.customPrices = proto.customPrices.map(CustomPriceMapping.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.revenue !== 'undefined' && this.revenue !== null) {
      toReturn['revenue'] = 'toApiJson' in this.revenue ? this.revenue.toApiJson() : this.revenue;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    if (typeof this.productIds !== 'undefined') {
      toReturn['productIds'] = this.productIds;
    }
    if (typeof this.addonKeys !== 'undefined' && this.addonKeys !== null) {
      toReturn['addonKeys'] = 'toApiJson' in this.addonKeys ? this.addonKeys.toApiJson() : this.addonKeys;
    }
    if (typeof this.customPrices !== 'undefined' && this.customPrices !== null) {
      toReturn['customPrices'] = 'toApiJson' in this.customPrices ? this.customPrices.toApiJson() : this.customPrices;
    }
    return toReturn;
  }
}
class Product {
  static fromProto(proto) {
    let m = new Product();
    m = Object.assign(m, proto);
    if (proto.currency) {
      m.currency = enumStringToValue$c(Currency, proto.currency);
    }
    if (proto.revenue) {
      m.revenue = Revenue.fromProto(proto.revenue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.revenue !== 'undefined' && this.revenue !== null) {
      toReturn['revenue'] = 'toApiJson' in this.revenue ? this.revenue.toApiJson() : this.revenue;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.parentProductId !== 'undefined') {
      toReturn['parentProductId'] = this.parentProductId;
    }
    return toReturn;
  }
}
class ProductActivation {
  static fromProto(proto) {
    let m = new ProductActivation();
    m = Object.assign(m, proto);
    if (proto.activationStatus) {
      m.activationStatus = enumStringToValue$c(ActivationStatus, proto.activationStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.activationStatus !== 'undefined') {
      toReturn['activationStatus'] = this.activationStatus;
    }
    if (typeof this.uniqueId !== 'undefined') {
      toReturn['uniqueId'] = this.uniqueId;
    }
    if (typeof this.previousEditionId !== 'undefined') {
      toReturn['previousEditionId'] = this.previousEditionId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.isEditionChange !== 'undefined') {
      toReturn['isEditionChange'] = this.isEditionChange;
    }
    return toReturn;
  }
}
class Salesperson {
  static fromProto(proto) {
    let m = new Salesperson();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    return toReturn;
  }
}
class StatusHistoryItem {
  static fromProto(proto) {
    let m = new StatusHistoryItem();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$c(Status, proto.status);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.source) {
      m.source = enumStringToValue$c(Source, proto.source);
    }
    if (proto.userRole) {
      m.userRole = enumStringToValue$c(UserRole, proto.userRole);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.metadata !== 'undefined') {
      toReturn['metadata'] = this.metadata;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.userRole !== 'undefined') {
      toReturn['userRole'] = this.userRole;
    }
    return toReturn;
  }
}
class User {
  static fromProto(proto) {
    let m = new User();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class IncludedCommonFormFields {
  static fromProto(proto) {
    let m = new IncludedCommonFormFields();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.businessAddress !== 'undefined') {
      toReturn['businessAddress'] = this.businessAddress;
    }
    if (typeof this.businessPhoneNumber !== 'undefined') {
      toReturn['businessPhoneNumber'] = this.businessPhoneNumber;
    }
    if (typeof this.businessAccountGroupId !== 'undefined') {
      toReturn['businessAccountGroupId'] = this.businessAccountGroupId;
    }
    if (typeof this.salespersonName !== 'undefined') {
      toReturn['salespersonName'] = this.salespersonName;
    }
    if (typeof this.salespersonPhoneNumber !== 'undefined') {
      toReturn['salespersonPhoneNumber'] = this.salespersonPhoneNumber;
    }
    if (typeof this.salespersonEmail !== 'undefined') {
      toReturn['salespersonEmail'] = this.salespersonEmail;
    }
    if (typeof this.contactName !== 'undefined') {
      toReturn['contactName'] = this.contactName;
    }
    if (typeof this.contactPhoneNumber !== 'undefined') {
      toReturn['contactPhoneNumber'] = this.contactPhoneNumber;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    if (typeof this.businessWebsite !== 'undefined') {
      toReturn['businessWebsite'] = this.businessWebsite;
    }
    return toReturn;
  }
}
class OrderFormFieldOption {
  static fromProto(proto) {
    let m = new OrderFormFieldOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class OrderForm {
  static fromProto(proto) {
    let m = new OrderForm();
    m = Object.assign(m, proto);
    if (proto.orderForm) {
      m.orderForm = proto.orderForm.map(OrderFormField.fromProto);
    }
    if (proto.commonForm) {
      m.commonForm = IncludedCommonFormFields.fromProto(proto.commonForm);
    }
    if (proto.commonFormRequiredFields) {
      m.commonFormRequiredFields = IncludedCommonFormFields.fromProto(proto.commonFormRequiredFields);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    if (typeof this.commonForm !== 'undefined' && this.commonForm !== null) {
      toReturn['commonForm'] = 'toApiJson' in this.commonForm ? this.commonForm.toApiJson() : this.commonForm;
    }
    if (typeof this.activationMessage !== 'undefined') {
      toReturn['activationMessage'] = this.activationMessage;
    }
    if (typeof this.separateOrderForms !== 'undefined') {
      toReturn['separateOrderForms'] = this.separateOrderForms;
    }
    if (typeof this.commonFormRequiredFields !== 'undefined' && this.commonFormRequiredFields !== null) {
      toReturn['commonFormRequiredFields'] = 'toApiJson' in this.commonFormRequiredFields ? this.commonFormRequiredFields.toApiJson() : this.commonFormRequiredFields;
    }
    if (typeof this.usesPostBillingOrderForm !== 'undefined') {
      toReturn['usesPostBillingOrderForm'] = this.usesPostBillingOrderForm;
    }
    if (typeof this.footerText !== 'undefined') {
      toReturn['footerText'] = this.footerText;
    }
    return toReturn;
  }
}
class OrderFormField {
  static fromProto(proto) {
    let m = new OrderFormField();
    m = Object.assign(m, proto);
    if (proto.maxChoices) {
      m.maxChoices = parseInt(proto.maxChoices, 10);
    }
    if (proto.optionsWithLabels) {
      m.optionsWithLabels = proto.optionsWithLabels.map(OrderFormFieldOption.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    if (typeof this.uploadUrl !== 'undefined') {
      toReturn['uploadUrl'] = this.uploadUrl;
    }
    if (typeof this.prefix !== 'undefined') {
      toReturn['prefix'] = this.prefix;
    }
    if (typeof this.suffix !== 'undefined') {
      toReturn['suffix'] = this.suffix;
    }
    if (typeof this.regexValidator !== 'undefined') {
      toReturn['regexValidator'] = this.regexValidator;
    }
    if (typeof this.regexErrorMessage !== 'undefined') {
      toReturn['regexErrorMessage'] = this.regexErrorMessage;
    }
    if (typeof this.useWebhookValidator !== 'undefined') {
      toReturn['useWebhookValidator'] = this.useWebhookValidator;
    }
    if (typeof this.allowMultiples !== 'undefined') {
      toReturn['allowMultiples'] = this.allowMultiples;
    }
    if (typeof this.allowDuplicates !== 'undefined') {
      toReturn['allowDuplicates'] = this.allowDuplicates;
    }
    if (typeof this.maxChoices !== 'undefined') {
      toReturn['maxChoices'] = this.maxChoices;
    }
    if (typeof this.forOfficeUseOnly !== 'undefined') {
      toReturn['forOfficeUseOnly'] = this.forOfficeUseOnly;
    }
    if (typeof this.optionsWithLabels !== 'undefined' && this.optionsWithLabels !== null) {
      toReturn['optionsWithLabels'] = 'toApiJson' in this.optionsWithLabels ? this.optionsWithLabels.toApiJson() : this.optionsWithLabels;
    }
    if (typeof this.officeEditableOnly !== 'undefined') {
      toReturn['officeEditableOnly'] = this.officeEditableOnly;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Config {
  static fromProto(proto) {
    let m = new Config();
    m = Object.assign(m, proto);
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(OrderFormField.fromProto);
    }
    if (proto.workflowStepOptions) {
      m.workflowStepOptions = WorkflowStepOptions.fromProto(proto.workflowStepOptions);
    }
    if (proto.salespersonOptions) {
      m.salespersonOptions = SalespersonOptions.fromProto(proto.salespersonOptions);
    }
    if (proto.taxOptions) {
      m.taxOptions = proto.taxOptions.map(TaxOptions.fromProto);
    }
    if (proto.customerTermsOfServiceOptions) {
      m.customerTermsOfServiceOptions = TermsOfServiceOptions.fromProto(proto.customerTermsOfServiceOptions);
    }
    if (proto.customerOptions) {
      m.customerOptions = CustomerOptions.fromProto(proto.customerOptions);
    }
    if (proto.emailOptions) {
      m.emailOptions = EmailOptions.fromProto(proto.emailOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.defaultNotesContent !== 'undefined') {
      toReturn['defaultNotesContent'] = this.defaultNotesContent;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    if (typeof this.termsOfServiceUrl !== 'undefined') {
      toReturn['termsOfServiceUrl'] = this.termsOfServiceUrl;
    }
    if (typeof this.workflowStepOptions !== 'undefined' && this.workflowStepOptions !== null) {
      toReturn['workflowStepOptions'] = 'toApiJson' in this.workflowStepOptions ? this.workflowStepOptions.toApiJson() : this.workflowStepOptions;
    }
    if (typeof this.salespersonOptions !== 'undefined' && this.salespersonOptions !== null) {
      toReturn['salespersonOptions'] = 'toApiJson' in this.salespersonOptions ? this.salespersonOptions.toApiJson() : this.salespersonOptions;
    }
    if (typeof this.taxOptions !== 'undefined' && this.taxOptions !== null) {
      toReturn['taxOptions'] = 'toApiJson' in this.taxOptions ? this.taxOptions.toApiJson() : this.taxOptions;
    }
    if (typeof this.customerTermsOfServiceOptions !== 'undefined' && this.customerTermsOfServiceOptions !== null) {
      toReturn['customerTermsOfServiceOptions'] = 'toApiJson' in this.customerTermsOfServiceOptions ? this.customerTermsOfServiceOptions.toApiJson() : this.customerTermsOfServiceOptions;
    }
    if (typeof this.customerOptions !== 'undefined' && this.customerOptions !== null) {
      toReturn['customerOptions'] = 'toApiJson' in this.customerOptions ? this.customerOptions.toApiJson() : this.customerOptions;
    }
    if (typeof this.emailOptions !== 'undefined' && this.emailOptions !== null) {
      toReturn['emailOptions'] = 'toApiJson' in this.emailOptions ? this.emailOptions.toApiJson() : this.emailOptions;
    }
    return toReturn;
  }
}
class CustomSalesPersonApproveAction {
  static fromProto(proto) {
    let m = new CustomSalesPersonApproveAction();
    m = Object.assign(m, proto);
    if (proto.customActions) {
      m.customActions = CustomSalespersonAction.fromProto(proto.customActions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customActions !== 'undefined' && this.customActions !== null) {
      toReturn['customActions'] = 'toApiJson' in this.customActions ? this.customActions.toApiJson() : this.customActions;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class CustomSalespersonAction {
  static fromProto(proto) {
    let m = new CustomSalespersonAction();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.automationId !== 'undefined') {
      toReturn['automationId'] = this.automationId;
    }
    return toReturn;
  }
}
class CustomerOptions {
  static fromProto(proto) {
    let m = new CustomerOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.allowCustomerInitiatedOrders !== 'undefined') {
      toReturn['allowCustomerInitiatedOrders'] = this.allowCustomerInitiatedOrders;
    }
    return toReturn;
  }
}
class EmailContent {
  static fromProto(proto) {
    let m = new EmailContent();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.heading !== 'undefined') {
      toReturn['heading'] = this.heading;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.button !== 'undefined') {
      toReturn['button'] = this.button;
    }
    return toReturn;
  }
}
class EmailCustomContent {
  static fromProto(proto) {
    let m = new EmailCustomContent();
    m = Object.assign(m, proto);
    if (proto.contractAwaitingApproval) {
      m.contractAwaitingApproval = EmailContent.fromProto(proto.contractAwaitingApproval);
    }
    if (proto.orderProcessed) {
      m.orderProcessed = EmailContent.fromProto(proto.orderProcessed);
    }
    if (proto.orderDeclined) {
      m.orderDeclined = EmailContent.fromProto(proto.orderDeclined);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contractAwaitingApproval !== 'undefined' && this.contractAwaitingApproval !== null) {
      toReturn['contractAwaitingApproval'] = 'toApiJson' in this.contractAwaitingApproval ? this.contractAwaitingApproval.toApiJson() : this.contractAwaitingApproval;
    }
    if (typeof this.orderProcessed !== 'undefined' && this.orderProcessed !== null) {
      toReturn['orderProcessed'] = 'toApiJson' in this.orderProcessed ? this.orderProcessed.toApiJson() : this.orderProcessed;
    }
    if (typeof this.orderDeclined !== 'undefined' && this.orderDeclined !== null) {
      toReturn['orderDeclined'] = 'toApiJson' in this.orderDeclined ? this.orderDeclined.toApiJson() : this.orderDeclined;
    }
    return toReturn;
  }
}
class EmailOptions {
  static fromProto(proto) {
    let m = new EmailOptions();
    m = Object.assign(m, proto);
    if (proto.emailCustomContent) {
      m.emailCustomContent = EmailCustomContent.fromProto(proto.emailCustomContent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailCustomContent !== 'undefined' && this.emailCustomContent !== null) {
      toReturn['emailCustomContent'] = 'toApiJson' in this.emailCustomContent ? this.emailCustomContent.toApiJson() : this.emailCustomContent;
    }
    return toReturn;
  }
}
class SalespersonOptions {
  static fromProto(proto) {
    let m = new SalespersonOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.validateRequiredFields !== 'undefined') {
      toReturn['validateRequiredFields'] = this.validateRequiredFields;
    }
    if (typeof this.disableSellingStandaloneProducts !== 'undefined') {
      toReturn['disableSellingStandaloneProducts'] = this.disableSellingStandaloneProducts;
    }
    if (typeof this.disableTagging !== 'undefined') {
      toReturn['disableTagging'] = this.disableTagging;
    }
    return toReturn;
  }
}
class TermsOfService {
  static fromProto(proto) {
    let m = new TermsOfService();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.termsOfServiceUrl !== 'undefined') {
      toReturn['termsOfServiceUrl'] = this.termsOfServiceUrl;
    }
    if (typeof this.linkTitle !== 'undefined') {
      toReturn['linkTitle'] = this.linkTitle;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    return toReturn;
  }
}
class TermsOfServiceOptions {
  static fromProto(proto) {
    let m = new TermsOfServiceOptions();
    m = Object.assign(m, proto);
    if (proto.termsOfService) {
      m.termsOfService = proto.termsOfService.map(TermsOfService.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hideDefaultTermsOfService !== 'undefined') {
      toReturn['hideDefaultTermsOfService'] = this.hideDefaultTermsOfService;
    }
    if (typeof this.termsOfService !== 'undefined' && this.termsOfService !== null) {
      toReturn['termsOfService'] = 'toApiJson' in this.termsOfService ? this.termsOfService.toApiJson() : this.termsOfService;
    }
    return toReturn;
  }
}
class WorkflowStepOptions {
  static fromProto(proto) {
    let m = new WorkflowStepOptions();
    m = Object.assign(m, proto);
    if (proto.customSalespersonActions) {
      m.customSalespersonActions = proto.customSalespersonActions.map(CustomSalespersonAction.fromProto);
    }
    if (proto.customApproveActions) {
      m.customApproveActions = CustomSalesPersonApproveAction.fromProto(proto.customApproveActions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.allowSendDirectToAdmin !== 'undefined') {
      toReturn['allowSendDirectToAdmin'] = this.allowSendDirectToAdmin;
    }
    if (typeof this.allowSendToCustomer !== 'undefined') {
      toReturn['allowSendToCustomer'] = this.allowSendToCustomer;
    }
    if (typeof this.maintainTermsAndConditionsAgreement !== 'undefined') {
      toReturn['maintainTermsAndConditionsAgreement'] = this.maintainTermsAndConditionsAgreement;
    }
    if (typeof this.customSalespersonActions !== 'undefined' && this.customSalespersonActions !== null) {
      toReturn['customSalespersonActions'] = 'toApiJson' in this.customSalespersonActions ? this.customSalespersonActions.toApiJson() : this.customSalespersonActions;
    }
    if (typeof this.allowOrderFormEditing !== 'undefined') {
      toReturn['allowOrderFormEditing'] = this.allowOrderFormEditing;
    }
    if (typeof this.allowCollectPaymentFromCustomer !== 'undefined') {
      toReturn['allowCollectPaymentFromCustomer'] = this.allowCollectPaymentFromCustomer;
    }
    if (typeof this.customApproveActions !== 'undefined' && this.customApproveActions !== null) {
      toReturn['customApproveActions'] = 'toApiJson' in this.customApproveActions ? this.customApproveActions.toApiJson() : this.customApproveActions;
    }
    if (typeof this.canChargeSmbOnOrderSubmission !== 'undefined') {
      toReturn['canChargeSmbOnOrderSubmission'] = this.canChargeSmbOnOrderSubmission;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ApproveRequest {
  static fromProto(proto) {
    let m = new ApproveRequest();
    m = Object.assign(m, proto);
    if (proto.agreements) {
      m.agreements = proto.agreements.map(Agreement.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.agreements !== 'undefined' && this.agreements !== null) {
      toReturn['agreements'] = 'toApiJson' in this.agreements ? this.agreements.toApiJson() : this.agreements;
    }
    return toReturn;
  }
}
class ApproveResponse {
  static fromProto(proto) {
    let m = new ApproveResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class DeclineRequest {
  static fromProto(proto) {
    let m = new DeclineRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.declinedReason !== 'undefined') {
      toReturn['declinedReason'] = this.declinedReason;
    }
    return toReturn;
  }
}
class DeclineResponse {
  static fromProto(proto) {
    let m = new DeclineResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class GetConfigurationRequest {
  static fromProto(proto) {
    let m = new GetConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class GetConfigurationResponse {
  static fromProto(proto) {
    let m = new GetConfigurationResponse();
    m = Object.assign(m, proto);
    if (proto.configuration) {
      m.configuration = Config.fromProto(proto.configuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configuration !== 'undefined' && this.configuration !== null) {
      toReturn['configuration'] = 'toApiJson' in this.configuration ? this.configuration.toApiJson() : this.configuration;
    }
    return toReturn;
  }
}
class GetOrderRecipientSessionRequest {
  static fromProto(proto) {
    let m = new GetOrderRecipientSessionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.token !== 'undefined') {
      toReturn['token'] = this.token;
    }
    return toReturn;
  }
}
class GetOrderRecipientSessionResponse {
  static fromProto(proto) {
    let m = new GetOrderRecipientSessionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.session !== 'undefined') {
      toReturn['session'] = this.session;
    }
    return toReturn;
  }
}
class GetRequest {
  static fromProto(proto) {
    let m = new GetRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class GetResponse {
  static fromProto(proto) {
    let m = new GetResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class UpdateOrderFormAnswersRequest {
  static fromProto(proto) {
    let m = new UpdateOrderFormAnswersRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(CommonField.fromProto);
    }
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(Field.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    return toReturn;
  }
}
class UpdateOrderFormAnswersResponse {
  static fromProto(proto) {
    let m = new UpdateOrderFormAnswersResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Subscriber {
  static fromProto(proto) {
    let m = new Subscriber();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = enumStringToValue$8(SubscriptionLocation, proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArchiveAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ArchiveAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class AuxiliaryDataFieldSchema {
  static fromProto(proto) {
    let m = new AuxiliaryDataFieldSchema();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue$5(AuxiliaryDataFieldType, proto.fieldType);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.dropdownOptions) {
      m.dropdownOptions = proto.dropdownOptions.map(DropdownOption.fromProto);
    }
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.fieldName !== 'undefined') {
      toReturn['fieldName'] = this.fieldName;
    }
    if (typeof this.fieldDescription !== 'undefined') {
      toReturn['fieldDescription'] = this.fieldDescription;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.dropdownOptions !== 'undefined' && this.dropdownOptions !== null) {
      toReturn['dropdownOptions'] = 'toApiJson' in this.dropdownOptions ? this.dropdownOptions.toApiJson() : this.dropdownOptions;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class AuxiliaryDataObjectID {
  static fromProto(proto) {
    let m = new AuxiliaryDataObjectID();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.objectId !== 'undefined') {
      toReturn['objectId'] = this.objectId;
    }
    return toReturn;
  }
}
class CreateAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new CreateAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class DropdownOption {
  static fromProto(proto) {
    let m = new DropdownOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class FieldDataUpsertOperation {
  static fromProto(proto) {
    let m = new FieldDataUpsertOperation();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.currencyValue) {
      m.currencyValue = parseInt(proto.currencyValue, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldDataId !== 'undefined') {
      toReturn['fieldDataId'] = this.fieldDataId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.dropdownValue !== 'undefined') {
      toReturn['dropdownValue'] = this.dropdownValue;
    }
    if (typeof this.currencyValue !== 'undefined') {
      toReturn['currencyValue'] = this.currencyValue;
    }
    if (typeof this.deleteValue !== 'undefined') {
      toReturn['deleteValue'] = this.deleteValue;
    }
    return toReturn;
  }
}
class FieldSchemaIdentifier {
  static fromProto(proto) {
    let m = new FieldSchemaIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaRequestFilters {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.onlyArchived !== 'undefined') {
      toReturn['onlyArchived'] = this.onlyArchived;
    }
    return toReturn;
  }
}
class GetAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class GetAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifiers) {
      m.identifiers = proto.identifiers.map(FieldSchemaIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifiers !== 'undefined' && this.identifiers !== null) {
      toReturn['identifiers'] = 'toApiJson' in this.identifiers ? this.identifiers.toApiJson() : this.identifiers;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(AuxiliaryDataFieldSchema.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.fieldIds !== 'undefined') {
      toReturn['fieldIds'] = this.fieldIds;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataResponse {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jsonSchema !== 'undefined') {
      toReturn['jsonSchema'] = this.jsonSchema;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListAuxiliaryDataFieldSchemaRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(AuxiliaryDataFieldSchema.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataResponse {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jsonSchema !== 'undefined') {
      toReturn['jsonSchema'] = this.jsonSchema;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UnarchiveAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UnarchiveAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class UpdateAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UpdateAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new UpsertAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    if (proto.fieldDataUpsertOperations) {
      m.fieldDataUpsertOperations = proto.fieldDataUpsertOperations.map(FieldDataUpsertOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.fieldDataUpsertOperations !== 'undefined' && this.fieldDataUpsertOperations !== null) {
      toReturn['fieldDataUpsertOperations'] = 'toApiJson' in this.fieldDataUpsertOperations ? this.fieldDataUpsertOperations.toApiJson() : this.fieldDataUpsertOperations;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ListSalesOderAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new ListSalesOderAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.salesOrderAuxiliaryDataObjectId) {
      m.salesOrderAuxiliaryDataObjectId = SalesOrderAuxiliaryDataObjectID.fromProto(proto.salesOrderAuxiliaryDataObjectId);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesOrderAuxiliaryDataObjectId !== 'undefined' && this.salesOrderAuxiliaryDataObjectId !== null) {
      toReturn['salesOrderAuxiliaryDataObjectId'] = 'toApiJson' in this.salesOrderAuxiliaryDataObjectId ? this.salesOrderAuxiliaryDataObjectId.toApiJson() : this.salesOrderAuxiliaryDataObjectId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class SalesOrderAuxiliaryDataObjectID {
  static fromProto(proto) {
    let m = new SalesOrderAuxiliaryDataObjectID();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class UpsertSalesOrderAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new UpsertSalesOrderAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.salesOrderAuxiliaryDataObjectId) {
      m.salesOrderAuxiliaryDataObjectId = SalesOrderAuxiliaryDataObjectID.fromProto(proto.salesOrderAuxiliaryDataObjectId);
    }
    if (proto.fieldDataUpsertOperations) {
      m.fieldDataUpsertOperations = proto.fieldDataUpsertOperations.map(FieldDataUpsertOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesOrderAuxiliaryDataObjectId !== 'undefined' && this.salesOrderAuxiliaryDataObjectId !== null) {
      toReturn['salesOrderAuxiliaryDataObjectId'] = 'toApiJson' in this.salesOrderAuxiliaryDataObjectId ? this.salesOrderAuxiliaryDataObjectId.toApiJson() : this.salesOrderAuxiliaryDataObjectId;
    }
    if (typeof this.fieldDataUpsertOperations !== 'undefined' && this.fieldDataUpsertOperations !== null) {
      toReturn['fieldDataUpsertOperations'] = 'toApiJson' in this.fieldDataUpsertOperations ? this.fieldDataUpsertOperations.toApiJson() : this.fieldDataUpsertOperations;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ValidationErrorList {
  static fromProto(proto) {
    let m = new ValidationErrorList();
    m = Object.assign(m, proto);
    if (proto.errorCodes) {
      m.errorCodes = proto.errorCodes.map(v => enumStringToValue$2(ValidationErrorCodes, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errorCodes !== 'undefined') {
      toReturn['errorCodes'] = this.errorCodes;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActivateProductsRequest {
  static fromProto(proto) {
    let m = new ActivateProductsRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(CommonField.fromProto);
    }
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(Field.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    return toReturn;
  }
}
class ActivateProductsResponse {
  static fromProto(proto) {
    let m = new ActivateProductsResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class ApproveCancellationRequest {
  static fromProto(proto) {
    let m = new ApproveCancellationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ApproveSalesOrderRequest {
  static fromProto(proto) {
    let m = new ApproveSalesOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ApproveSalesOrderResponse {
  static fromProto(proto) {
    let m = new ApproveSalesOrderResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class ArchiveReasonRequest {
  static fromProto(proto) {
    let m = new ArchiveReasonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class ArchiveSalesOrderRequest {
  static fromProto(proto) {
    let m = new ArchiveSalesOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ArchiveSalesOrderResponse {
  static fromProto(proto) {
    let m = new ArchiveSalesOrderResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class CancelOrderRequest {
  static fromProto(proto) {
    let m = new CancelOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class ChargeOrderRequest {
  static fromProto(proto) {
    let m = new ChargeOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ChargeOrderResponse {
  static fromProto(proto) {
    let m = new ChargeOrderResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class CheckSalesOrderExistsRequest {
  static fromProto(proto) {
    let m = new CheckSalesOrderExistsRequest();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$1(Status, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.productEditionId !== 'undefined') {
      toReturn['productEditionId'] = this.productEditionId;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    return toReturn;
  }
}
class CheckSalesOrderExistsResponse {
  static fromProto(proto) {
    let m = new CheckSalesOrderExistsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exists !== 'undefined') {
      toReturn['exists'] = this.exists;
    }
    return toReturn;
  }
}
class ConvertToDraftRequest {
  static fromProto(proto) {
    let m = new ConvertToDraftRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetStatusCountsResponseCountsEntry {
  static fromProto(proto) {
    let m = new GetStatusCountsResponseCountsEntry();
    m = Object.assign(m, proto);
    if (proto.key) {
      m.key = parseInt(proto.key, 10);
    }
    if (proto.value) {
      m.value = parseInt(proto.value, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class CreateAndActivateOrderRequest {
  static fromProto(proto) {
    let m = new CreateAndActivateOrderRequest();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    if (typeof this.useCustomerPrice !== 'undefined') {
      toReturn['useCustomerPrice'] = this.useCustomerPrice;
    }
    return toReturn;
  }
}
class CreateAndActivateOrderResponse {
  static fromProto(proto) {
    let m = new CreateAndActivateOrderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class CreateArchivedOrderRequest {
  static fromProto(proto) {
    let m = new CreateArchivedOrderRequest();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class CreateArchivedOrderResponse {
  static fromProto(proto) {
    let m = new CreateArchivedOrderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class CreateDraftSalesOrderRequest {
  static fromProto(proto) {
    let m = new CreateDraftSalesOrderRequest();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    if (typeof this.useCustomerPrice !== 'undefined') {
      toReturn['useCustomerPrice'] = this.useCustomerPrice;
    }
    return toReturn;
  }
}
class CreateDraftSalesOrderResponse {
  static fromProto(proto) {
    let m = new CreateDraftSalesOrderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class CreateForPartnerApprovalRequest {
  static fromProto(proto) {
    let m = new CreateForPartnerApprovalRequest();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class CreateForPartnerApprovalResponse {
  static fromProto(proto) {
    let m = new CreateForPartnerApprovalResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class CreateInvoiceRequest {
  static fromProto(proto) {
    let m = new CreateInvoiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class CreateInvoiceResponse {
  static fromProto(proto) {
    let m = new CreateInvoiceResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invoiceId !== 'undefined') {
      toReturn['invoiceId'] = this.invoiceId;
    }
    return toReturn;
  }
}
class CreateLeasedToAutomationsSalesOrderRequest {
  static fromProto(proto) {
    let m = new CreateLeasedToAutomationsSalesOrderRequest();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    if (typeof this.useCustomerPrice !== 'undefined') {
      toReturn['useCustomerPrice'] = this.useCustomerPrice;
    }
    return toReturn;
  }
}
class CreateLeasedToAutomationsSalesOrderResponse {
  static fromProto(proto) {
    let m = new CreateLeasedToAutomationsSalesOrderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class CreateReasonRequest {
  static fromProto(proto) {
    let m = new CreateReasonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class CreateReasonResponse {
  static fromProto(proto) {
    let m = new CreateReasonResponse();
    m = Object.assign(m, proto);
    if (proto.declinedReason) {
      m.declinedReason = DeclinedReason.fromProto(proto.declinedReason);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.declinedReason !== 'undefined' && this.declinedReason !== null) {
      toReturn['declinedReason'] = 'toApiJson' in this.declinedReason ? this.declinedReason.toApiJson() : this.declinedReason;
    }
    return toReturn;
  }
}
class CreateSalesOrderRequest {
  static fromProto(proto) {
    let m = new CreateSalesOrderRequest();
    m = Object.assign(m, proto);
    if (proto.requestedActivation) {
      m.requestedActivation = new Date(proto.requestedActivation);
    }
    if (proto.packages) {
      m.packages = proto.packages.map(Package.fromProto);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(CommonField.fromProto);
    }
    if (proto.products) {
      m.products = proto.products.map(Product.fromProto);
    }
    if (proto.origin) {
      m.origin = enumStringToValue$1(Origin, proto.origin);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(Field.fromProto);
    }
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(LineItem.fromProto);
    }
    if (proto.contractDuration) {
      m.contractDuration = Duration.fromProto(proto.contractDuration);
    }
    if (proto.customerAttachments) {
      m.customerAttachments = proto.customerAttachments.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.opportunityIds !== 'undefined') {
      toReturn['opportunityIds'] = this.opportunityIds;
    }
    if (typeof this.requestedActivation !== 'undefined' && this.requestedActivation !== null) {
      toReturn['requestedActivation'] = 'toApiJson' in this.requestedActivation ? this.requestedActivation.toApiJson() : this.requestedActivation;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    if (typeof this.packages !== 'undefined' && this.packages !== null) {
      toReturn['packages'] = 'toApiJson' in this.packages ? this.packages.toApiJson() : this.packages;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.products !== 'undefined' && this.products !== null) {
      toReturn['products'] = 'toApiJson' in this.products ? this.products.toApiJson() : this.products;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    if (typeof this.contractDuration !== 'undefined' && this.contractDuration !== null) {
      toReturn['contractDuration'] = 'toApiJson' in this.contractDuration ? this.contractDuration.toApiJson() : this.contractDuration;
    }
    if (typeof this.customerNotes !== 'undefined') {
      toReturn['customerNotes'] = this.customerNotes;
    }
    if (typeof this.quoteId !== 'undefined') {
      toReturn['quoteId'] = this.quoteId;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.useCustomerPrice !== 'undefined') {
      toReturn['useCustomerPrice'] = this.useCustomerPrice;
    }
    if (typeof this.orderIsSmbPayable !== 'undefined') {
      toReturn['orderIsSmbPayable'] = this.orderIsSmbPayable;
    }
    if (typeof this.enforceContractTerm !== 'undefined') {
      toReturn['enforceContractTerm'] = this.enforceContractTerm;
    }
    if (typeof this.customerAttachments !== 'undefined' && this.customerAttachments !== null) {
      toReturn['customerAttachments'] = 'toApiJson' in this.customerAttachments ? this.customerAttachments.toApiJson() : this.customerAttachments;
    }
    return toReturn;
  }
}
class CreateSalesOrderResponse {
  static fromProto(proto) {
    let m = new CreateSalesOrderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class CreateWithPaymentIntentRequest {
  static fromProto(proto) {
    let m = new CreateWithPaymentIntentRequest();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class CreateWithPaymentIntentResponse {
  static fromProto(proto) {
    let m = new CreateWithPaymentIntentResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class CustomerApproveSalesOrderRequest {
  static fromProto(proto) {
    let m = new CustomerApproveSalesOrderRequest();
    m = Object.assign(m, proto);
    if (proto.agreements) {
      m.agreements = proto.agreements.map(Agreement.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.agreements !== 'undefined' && this.agreements !== null) {
      toReturn['agreements'] = 'toApiJson' in this.agreements ? this.agreements.toApiJson() : this.agreements;
    }
    if (typeof this.paymentMethodToken !== 'undefined') {
      toReturn['paymentMethodToken'] = this.paymentMethodToken;
    }
    return toReturn;
  }
}
class CustomerApproveSalesOrderResponse {
  static fromProto(proto) {
    let m = new CustomerApproveSalesOrderResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class CustomerCreateSalesOrderRequest {
  static fromProto(proto) {
    let m = new CustomerCreateSalesOrderRequest();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class CustomerCreateSalesOrderResponse {
  static fromProto(proto) {
    let m = new CustomerCreateSalesOrderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class CustomerGetConfigurationRequest {
  static fromProto(proto) {
    let m = new CustomerGetConfigurationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ListOrdersRequestDateRangeFilter {
  static fromProto(proto) {
    let m = new ListOrdersRequestDateRangeFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class InitiateOrderExportRequestDateRangeFilter {
  static fromProto(proto) {
    let m = new InitiateOrderExportRequestDateRangeFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class ListCustomerSalesOrderRequestDateRangeFilter {
  static fromProto(proto) {
    let m = new ListCustomerSalesOrderRequestDateRangeFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class ListSalesOrderRequestDateRangeFilter {
  static fromProto(proto) {
    let m = new ListSalesOrderRequestDateRangeFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class DeclineCancellationRequest {
  static fromProto(proto) {
    let m = new DeclineCancellationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class DeclineSalesOrderRequest {
  static fromProto(proto) {
    let m = new DeclineSalesOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.declinedReason !== 'undefined') {
      toReturn['declinedReason'] = this.declinedReason;
    }
    if (typeof this.declinedReasonIds !== 'undefined') {
      toReturn['declinedReasonIds'] = this.declinedReasonIds;
    }
    return toReturn;
  }
}
class DeclineSalesOrderResponse {
  static fromProto(proto) {
    let m = new DeclineSalesOrderResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class DeleteConfigRequest {
  static fromProto(proto) {
    let m = new DeleteConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class DeleteSalesOrderRequest {
  static fromProto(proto) {
    let m = new DeleteSalesOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class DuplicateSalesOrderRequest {
  static fromProto(proto) {
    let m = new DuplicateSalesOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class DuplicateSalesOrderResponse {
  static fromProto(proto) {
    let m = new DuplicateSalesOrderResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class ListCustomerSalesOrderRequestFilters {
  static fromProto(proto) {
    let m = new ListCustomerSalesOrderRequestFilters();
    m = Object.assign(m, proto);
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$1(Status, v));
    }
    if (proto.created) {
      m.created = ListCustomerSalesOrderRequestDateRangeFilter.fromProto(proto.created);
    }
    if (proto.requestedActivation) {
      m.requestedActivation = ListCustomerSalesOrderRequestDateRangeFilter.fromProto(proto.requestedActivation);
    }
    if (proto.expiryDate) {
      m.expiryDate = ListCustomerSalesOrderRequestDateRangeFilter.fromProto(proto.expiryDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.requestedActivation !== 'undefined' && this.requestedActivation !== null) {
      toReturn['requestedActivation'] = 'toApiJson' in this.requestedActivation ? this.requestedActivation.toApiJson() : this.requestedActivation;
    }
    if (typeof this.expiryDate !== 'undefined' && this.expiryDate !== null) {
      toReturn['expiryDate'] = 'toApiJson' in this.expiryDate ? this.expiryDate.toApiJson() : this.expiryDate;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ListSalesOrderRequestFilters {
  static fromProto(proto) {
    let m = new ListSalesOrderRequestFilters();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = ListSalesOrderRequestDateRangeFilter.fromProto(proto.created);
    }
    if (proto.requestedActivation) {
      m.requestedActivation = ListSalesOrderRequestDateRangeFilter.fromProto(proto.requestedActivation);
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$1(Status, v));
    }
    if (proto.expiryDate) {
      m.expiryDate = ListSalesOrderRequestDateRangeFilter.fromProto(proto.expiryDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.requestedActivation !== 'undefined' && this.requestedActivation !== null) {
      toReturn['requestedActivation'] = 'toApiJson' in this.requestedActivation ? this.requestedActivation.toApiJson() : this.requestedActivation;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.productEditionId !== 'undefined') {
      toReturn['productEditionId'] = this.productEditionId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.untagged !== 'undefined') {
      toReturn['untagged'] = this.untagged;
    }
    if (typeof this.packageId !== 'undefined') {
      toReturn['packageId'] = this.packageId;
    }
    if (typeof this.expiryDate !== 'undefined' && this.expiryDate !== null) {
      toReturn['expiryDate'] = 'toApiJson' in this.expiryDate ? this.expiryDate.toApiJson() : this.expiryDate;
    }
    if (typeof this.salespersonIds !== 'undefined') {
      toReturn['salespersonIds'] = this.salespersonIds;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.orderIds !== 'undefined') {
      toReturn['orderIds'] = this.orderIds;
    }
    if (typeof this.includeArchivedOrders !== 'undefined') {
      toReturn['includeArchivedOrders'] = this.includeArchivedOrders;
    }
    return toReturn;
  }
}
class GetStatusCountsRequestFilters {
  static fromProto(proto) {
    let m = new GetStatusCountsRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    return toReturn;
  }
}
class ListOrdersRequestFilters {
  static fromProto(proto) {
    let m = new ListOrdersRequestFilters();
    m = Object.assign(m, proto);
    if (proto.activationStatuses) {
      m.activationStatuses = proto.activationStatuses.map(v => enumStringToValue$1(ActivationStatus, v));
    }
    if (proto.created) {
      m.created = ListOrdersRequestDateRangeFilter.fromProto(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resellerIds !== 'undefined') {
      toReturn['resellerIds'] = this.resellerIds;
    }
    if (typeof this.activationStatuses !== 'undefined') {
      toReturn['activationStatuses'] = this.activationStatuses;
    }
    if (typeof this.fulfillmentStatuses !== 'undefined') {
      toReturn['fulfillmentStatuses'] = this.fulfillmentStatuses;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.excludeChildren !== 'undefined') {
      toReturn['excludeChildren'] = this.excludeChildren;
    }
    if (typeof this.excludeAppIds !== 'undefined') {
      toReturn['excludeAppIds'] = this.excludeAppIds;
    }
    if (typeof this.excludeResellerIds !== 'undefined') {
      toReturn['excludeResellerIds'] = this.excludeResellerIds;
    }
    return toReturn;
  }
}
class InitiateOrderExportRequestFilters {
  static fromProto(proto) {
    let m = new InitiateOrderExportRequestFilters();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = InitiateOrderExportRequestDateRangeFilter.fromProto(proto.created);
    }
    if (proto.requestedActivation) {
      m.requestedActivation = InitiateOrderExportRequestDateRangeFilter.fromProto(proto.requestedActivation);
    }
    if (proto.expiryDate) {
      m.expiryDate = InitiateOrderExportRequestDateRangeFilter.fromProto(proto.expiryDate);
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue$1(Status, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.salespersonIds !== 'undefined') {
      toReturn['salespersonIds'] = this.salespersonIds;
    }
    if (typeof this.salesTeamIds !== 'undefined') {
      toReturn['salesTeamIds'] = this.salesTeamIds;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.requestedActivation !== 'undefined' && this.requestedActivation !== null) {
      toReturn['requestedActivation'] = 'toApiJson' in this.requestedActivation ? this.requestedActivation.toApiJson() : this.requestedActivation;
    }
    if (typeof this.expiryDate !== 'undefined' && this.expiryDate !== null) {
      toReturn['expiryDate'] = 'toApiJson' in this.expiryDate ? this.expiryDate.toApiJson() : this.expiryDate;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.untagged !== 'undefined') {
      toReturn['untagged'] = this.untagged;
    }
    if (typeof this.packageIds !== 'undefined') {
      toReturn['packageIds'] = this.packageIds;
    }
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class ListReasonsRequestFilters {
  static fromProto(proto) {
    let m = new ListReasonsRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeArchived !== 'undefined') {
      toReturn['includeArchived'] = this.includeArchived;
    }
    return toReturn;
  }
}
class ListTagsRequestFilters {
  static fromProto(proto) {
    let m = new ListTagsRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    return toReturn;
  }
}
class FulfillmentStatus {
  static fromProto(proto) {
    let m = new FulfillmentStatus();
    m = Object.assign(m, proto);
    if (proto.dueDate) {
      m.dueDate = new Date(proto.dueDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.dueDate !== 'undefined' && this.dueDate !== null) {
      toReturn['dueDate'] = 'toApiJson' in this.dueDate ? this.dueDate.toApiJson() : this.dueDate;
    }
    if (typeof this.assignee !== 'undefined') {
      toReturn['assignee'] = this.assignee;
    }
    if (typeof this.projectId !== 'undefined') {
      toReturn['projectId'] = this.projectId;
    }
    if (typeof this.projectName !== 'undefined') {
      toReturn['projectName'] = this.projectName;
    }
    return toReturn;
  }
}
class GetConfigRequest {
  static fromProto(proto) {
    let m = new GetConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetConfigResponse {
  static fromProto(proto) {
    let m = new GetConfigResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = Config.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class GetMultiSalesOrderRequest {
  static fromProto(proto) {
    let m = new GetMultiSalesOrderRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderIds !== 'undefined') {
      toReturn['orderIds'] = this.orderIds;
    }
    return toReturn;
  }
}
class GetMultiSalesOrderResponse {
  static fromProto(proto) {
    let m = new GetMultiSalesOrderResponse();
    m = Object.assign(m, proto);
    if (proto.orders) {
      m.orders = proto.orders.map(Order.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orders !== 'undefined' && this.orders !== null) {
      toReturn['orders'] = 'toApiJson' in this.orders ? this.orders.toApiJson() : this.orders;
    }
    return toReturn;
  }
}
class GetReasonRequest {
  static fromProto(proto) {
    let m = new GetReasonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetReasonResponse {
  static fromProto(proto) {
    let m = new GetReasonResponse();
    m = Object.assign(m, proto);
    if (proto.declinedReason) {
      m.declinedReason = DeclinedReason.fromProto(proto.declinedReason);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.declinedReason !== 'undefined' && this.declinedReason !== null) {
      toReturn['declinedReason'] = 'toApiJson' in this.declinedReason ? this.declinedReason.toApiJson() : this.declinedReason;
    }
    return toReturn;
  }
}
class GetSalesOrderByIdempotencyKeyRequest {
  static fromProto(proto) {
    let m = new GetSalesOrderByIdempotencyKeyRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    return toReturn;
  }
}
class GetSalesOrderRequest {
  static fromProto(proto) {
    let m = new GetSalesOrderRequest();
    m = Object.assign(m, proto);
    if (proto.projectionFilter) {
      m.projectionFilter = SalesOrderProjectionFilter.fromProto(proto.projectionFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    return toReturn;
  }
}
class GetSalesOrderResponse {
  static fromProto(proto) {
    let m = new GetSalesOrderResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class GetStatusCountsRequest {
  static fromProto(proto) {
    let m = new GetStatusCountsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = GetStatusCountsRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class GetStatusCountsResponse {
  static fromProto(proto) {
    let m = new GetStatusCountsResponse();
    m = Object.assign(m, proto);
    if (proto.counts) {
      m.counts = Object.keys(proto.counts).reduce((obj, k) => {
        obj[k] = parseInt(proto.counts[k], 10);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.counts !== 'undefined' && this.counts !== null) {
      toReturn['counts'] = 'toApiJson' in this.counts ? this.counts.toApiJson() : this.counts;
    }
    return toReturn;
  }
}
class GetSubscribedLocationsRequest {
  static fromProto(proto) {
    let m = new GetSubscribedLocationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetSubscribedLocationsResponse {
  static fromProto(proto) {
    let m = new GetSubscribedLocationsResponse();
    m = Object.assign(m, proto);
    if (proto.locations) {
      m.locations = proto.locations.map(v => enumStringToValue$1(SubscriptionLocation, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locations !== 'undefined') {
      toReturn['locations'] = this.locations;
    }
    return toReturn;
  }
}
class GetSubscribersRequest {
  static fromProto(proto) {
    let m = new GetSubscribersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetSubscribersResponse {
  static fromProto(proto) {
    let m = new GetSubscribersResponse();
    m = Object.assign(m, proto);
    if (proto.subscribers) {
      m.subscribers = proto.subscribers.map(Subscriber.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subscribers !== 'undefined' && this.subscribers !== null) {
      toReturn['subscribers'] = 'toApiJson' in this.subscribers ? this.subscribers.toApiJson() : this.subscribers;
    }
    return toReturn;
  }
}
class GetUsersRequest {
  static fromProto(proto) {
    let m = new GetUsersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetUsersResponse {
  static fromProto(proto) {
    let m = new GetUsersResponse();
    m = Object.assign(m, proto);
    if (proto.users) {
      m.users = Object.keys(proto.users).reduce((obj, k) => {
        obj[k] = User.fromProto(proto.users[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.users !== 'undefined' && this.users !== null) {
      toReturn['users'] = 'toApiJson' in this.users ? this.users.toApiJson() : this.users;
    }
    return toReturn;
  }
}
class IgnoreAllProductActivationErrorsRequest {
  static fromProto(proto) {
    let m = new IgnoreAllProductActivationErrorsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class IgnoreProductActivationErrorRequest {
  static fromProto(proto) {
    let m = new IgnoreProductActivationErrorRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.productActivationUniqueId !== 'undefined') {
      toReturn['productActivationUniqueId'] = this.productActivationUniqueId;
    }
    return toReturn;
  }
}
class InitiateOrderExportRequest {
  static fromProto(proto) {
    let m = new InitiateOrderExportRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = InitiateOrderExportRequestFilters.fromProto(proto.filters);
    }
    if (proto.sortOption) {
      m.sortOption = InitiateOrderExportRequestSortOption.fromProto(proto.sortOption);
    }
    if (proto.selectedDataFormat) {
      m.selectedDataFormat = enumStringToValue$1(InitiateOrderExportRequestDataFormatOption, proto.selectedDataFormat);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.sortOption !== 'undefined' && this.sortOption !== null) {
      toReturn['sortOption'] = 'toApiJson' in this.sortOption ? this.sortOption.toApiJson() : this.sortOption;
    }
    if (typeof this.tryAgainUrl !== 'undefined') {
      toReturn['tryAgainUrl'] = this.tryAgainUrl;
    }
    if (typeof this.selectedDataFormat !== 'undefined') {
      toReturn['selectedDataFormat'] = this.selectedDataFormat;
    }
    return toReturn;
  }
}
class InitiateOrderExportResponse {
  static fromProto(proto) {
    let m = new InitiateOrderExportResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exportId !== 'undefined') {
      toReturn['exportId'] = this.exportId;
    }
    return toReturn;
  }
}
class LeaseData {
  static fromProto(proto) {
    let m = new LeaseData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionType !== 'undefined') {
      toReturn['actionType'] = this.actionType;
    }
    if (typeof this.declinedReason !== 'undefined') {
      toReturn['declinedReason'] = this.declinedReason;
    }
    if (typeof this.declinedReasonIds !== 'undefined') {
      toReturn['declinedReasonIds'] = this.declinedReasonIds;
    }
    return toReturn;
  }
}
class LeaseSalesOrderToAutomationsRequest {
  static fromProto(proto) {
    let m = new LeaseSalesOrderToAutomationsRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(CommonField.fromProto);
    }
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(Field.fromProto);
    }
    if (proto.leaseData) {
      m.leaseData = LeaseData.fromProto(proto.leaseData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    if (typeof this.leaseData !== 'undefined' && this.leaseData !== null) {
      toReturn['leaseData'] = 'toApiJson' in this.leaseData ? this.leaseData.toApiJson() : this.leaseData;
    }
    return toReturn;
  }
}
class LeaseSalesOrderToAutomationsResponse {
  static fromProto(proto) {
    let m = new LeaseSalesOrderToAutomationsResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class ValidateLineItemsResponseLineItemErrorsEntry {
  static fromProto(proto) {
    let m = new ValidateLineItemsResponseLineItemErrorsEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ValidationErrorList.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class ListCustomerSalesOrderRequest {
  static fromProto(proto) {
    let m = new ListCustomerSalesOrderRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListCustomerSalesOrderRequestFilters.fromProto(proto.filters);
    }
    if (proto.sortOption) {
      m.sortOption = ListCustomerSalesOrderRequestSortOption.fromProto(proto.sortOption);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.sortOption !== 'undefined' && this.sortOption !== null) {
      toReturn['sortOption'] = 'toApiJson' in this.sortOption ? this.sortOption.toApiJson() : this.sortOption;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListOrdersRequest {
  static fromProto(proto) {
    let m = new ListOrdersRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListOrdersRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListOrdersResponse {
  static fromProto(proto) {
    let m = new ListOrdersResponse();
    m = Object.assign(m, proto);
    if (proto.orders) {
      m.orders = proto.orders.map(VendorOrder.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orders !== 'undefined' && this.orders !== null) {
      toReturn['orders'] = 'toApiJson' in this.orders ? this.orders.toApiJson() : this.orders;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ListReasonsRequest {
  static fromProto(proto) {
    let m = new ListReasonsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListReasonsRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListReasonsResponse {
  static fromProto(proto) {
    let m = new ListReasonsResponse();
    m = Object.assign(m, proto);
    if (proto.declinedReasons) {
      m.declinedReasons = proto.declinedReasons.map(DeclinedReason.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.declinedReasons !== 'undefined' && this.declinedReasons !== null) {
      toReturn['declinedReasons'] = 'toApiJson' in this.declinedReasons ? this.declinedReasons.toApiJson() : this.declinedReasons;
    }
    return toReturn;
  }
}
class ListSalesOrderRequest {
  static fromProto(proto) {
    let m = new ListSalesOrderRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSalesOrderRequestFilters.fromProto(proto.filters);
    }
    if (proto.sortOption) {
      m.sortOption = ListSalesOrderRequestSortOption.fromProto(proto.sortOption);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.sortOption !== 'undefined' && this.sortOption !== null) {
      toReturn['sortOption'] = 'toApiJson' in this.sortOption ? this.sortOption.toApiJson() : this.sortOption;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListSalesOrderResponse {
  static fromProto(proto) {
    let m = new ListSalesOrderResponse();
    m = Object.assign(m, proto);
    if (proto.orders) {
      m.orders = proto.orders.map(Order.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orders !== 'undefined' && this.orders !== null) {
      toReturn['orders'] = 'toApiJson' in this.orders ? this.orders.toApiJson() : this.orders;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ListTagsRequest {
  static fromProto(proto) {
    let m = new ListTagsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListTagsRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListTagsResponse {
  static fromProto(proto) {
    let m = new ListTagsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class PreviewOrderActivationsRequest {
  static fromProto(proto) {
    let m = new PreviewOrderActivationsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class PreviewOrderActivationsResponse {
  static fromProto(proto) {
    let m = new PreviewOrderActivationsResponse();
    m = Object.assign(m, proto);
    if (proto.productActivations) {
      m.productActivations = proto.productActivations.map(ProductActivation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productActivations !== 'undefined' && this.productActivations !== null) {
      toReturn['productActivations'] = 'toApiJson' in this.productActivations ? this.productActivations.toApiJson() : this.productActivations;
    }
    return toReturn;
  }
}
class Pricing {
  static fromProto(proto) {
    let m = new Pricing();
    m = Object.assign(m, proto);
    if (proto.amount) {
      m.amount = parseInt(proto.amount, 10);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    return toReturn;
  }
}
class RequestCancellationRequest {
  static fromProto(proto) {
    let m = new RequestCancellationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class SalesOrderProjectionFilter {
  static fromProto(proto) {
    let m = new SalesOrderProjectionFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeUserInfoInStatusHistory !== 'undefined') {
      toReturn['includeUserInfoInStatusHistory'] = this.includeUserInfoInStatusHistory;
    }
    if (typeof this.includeCustomerRecipient !== 'undefined') {
      toReturn['includeCustomerRecipient'] = this.includeCustomerRecipient;
    }
    return toReturn;
  }
}
class ScheduleActivationRequest {
  static fromProto(proto) {
    let m = new ScheduleActivationRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(CommonField.fromProto);
    }
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(Field.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    return toReturn;
  }
}
class SendExistingOrderToCustomerForApprovalRequest {
  static fromProto(proto) {
    let m = new SendExistingOrderToCustomerForApprovalRequest();
    m = Object.assign(m, proto);
    if (proto.offerExpiry) {
      m.offerExpiry = new Date(proto.offerExpiry);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.offerExpiry !== 'undefined' && this.offerExpiry !== null) {
      toReturn['offerExpiry'] = 'toApiJson' in this.offerExpiry ? this.offerExpiry.toApiJson() : this.offerExpiry;
    }
    if (typeof this.orderIsSmbPayable !== 'undefined') {
      toReturn['orderIsSmbPayable'] = this.orderIsSmbPayable;
    }
    return toReturn;
  }
}
class SendForCustomerApprovalRequest {
  static fromProto(proto) {
    let m = new SendForCustomerApprovalRequest();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    if (proto.offerExpiry) {
      m.offerExpiry = new Date(proto.offerExpiry);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.offerExpiry !== 'undefined' && this.offerExpiry !== null) {
      toReturn['offerExpiry'] = 'toApiJson' in this.offerExpiry ? this.offerExpiry.toApiJson() : this.offerExpiry;
    }
    if (typeof this.useCustomerPrice !== 'undefined') {
      toReturn['useCustomerPrice'] = this.useCustomerPrice;
    }
    return toReturn;
  }
}
class SendForCustomerApprovalResponse {
  static fromProto(proto) {
    let m = new SendForCustomerApprovalResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class ListSalesOrderRequestSortOption {
  static fromProto(proto) {
    let m = new ListSalesOrderRequestSortOption();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$1(ListSalesOrderRequestSortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue$1(ListSalesOrderRequestSortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class InitiateOrderExportRequestSortOption {
  static fromProto(proto) {
    let m = new InitiateOrderExportRequestSortOption();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$1(InitiateOrderExportRequestSortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue$1(InitiateOrderExportRequestSortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class ListCustomerSalesOrderRequestSortOption {
  static fromProto(proto) {
    let m = new ListCustomerSalesOrderRequestSortOption();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$1(ListCustomerSalesOrderRequestSortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue$1(ListCustomerSalesOrderRequestSortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class SubmitDraftForApprovalRequest {
  static fromProto(proto) {
    let m = new SubmitDraftForApprovalRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(CommonField.fromProto);
    }
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(Field.fromProto);
    }
    if (proto.offerExpiry) {
      m.offerExpiry = new Date(proto.offerExpiry);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    if (typeof this.offerExpiry !== 'undefined' && this.offerExpiry !== null) {
      toReturn['offerExpiry'] = 'toApiJson' in this.offerExpiry ? this.offerExpiry.toApiJson() : this.offerExpiry;
    }
    return toReturn;
  }
}
class SubmitDraftForApprovalResponse {
  static fromProto(proto) {
    let m = new SubmitDraftForApprovalResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class SubmitDraftRequest {
  static fromProto(proto) {
    let m = new SubmitDraftRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(CommonField.fromProto);
    }
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(Field.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    return toReturn;
  }
}
class SubmitDraftResponse {
  static fromProto(proto) {
    let m = new SubmitDraftResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class SubscribeRequest {
  static fromProto(proto) {
    let m = new SubscribeRequest();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = enumStringToValue$1(SubscriptionLocation, proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    return toReturn;
  }
}
class UnsubscribeRequest {
  static fromProto(proto) {
    let m = new UnsubscribeRequest();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = enumStringToValue$1(SubscriptionLocation, proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.location !== 'undefined') {
      toReturn['location'] = this.location;
    }
    return toReturn;
  }
}
class UpdateAnswersRequest {
  static fromProto(proto) {
    let m = new UpdateAnswersRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.commonFields) {
      m.commonFields = proto.commonFields.map(CommonField.fromProto);
    }
    if (proto.extraFields) {
      m.extraFields = proto.extraFields.map(Field.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.commonFields !== 'undefined' && this.commonFields !== null) {
      toReturn['commonFields'] = 'toApiJson' in this.commonFields ? this.commonFields.toApiJson() : this.commonFields;
    }
    if (typeof this.extraFields !== 'undefined' && this.extraFields !== null) {
      toReturn['extraFields'] = 'toApiJson' in this.extraFields ? this.extraFields.toApiJson() : this.extraFields;
    }
    return toReturn;
  }
}
class UpdateAnswersResponse {
  static fromProto(proto) {
    let m = new UpdateAnswersResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class UpdateAttachmentsRequest {
  static fromProto(proto) {
    let m = new UpdateAttachmentsRequest();
    m = Object.assign(m, proto);
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    return toReturn;
  }
}
class UpdateConfigRequest {
  static fromProto(proto) {
    let m = new UpdateConfigRequest();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = Config.fromProto(proto.config);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateContractDurationRequest {
  static fromProto(proto) {
    let m = new UpdateContractDurationRequest();
    m = Object.assign(m, proto);
    if (proto.contractDuration) {
      m.contractDuration = Duration.fromProto(proto.contractDuration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.contractDuration !== 'undefined' && this.contractDuration !== null) {
      toReturn['contractDuration'] = 'toApiJson' in this.contractDuration ? this.contractDuration.toApiJson() : this.contractDuration;
    }
    return toReturn;
  }
}
class UpdateCurrentRevenueRequest {
  static fromProto(proto) {
    let m = new UpdateCurrentRevenueRequest();
    m = Object.assign(m, proto);
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(LineItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    return toReturn;
  }
}
class UpdateCustomerAttachmentsRequest {
  static fromProto(proto) {
    let m = new UpdateCustomerAttachmentsRequest();
    m = Object.assign(m, proto);
    if (proto.attachments) {
      m.attachments = proto.attachments.map(Attachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    return toReturn;
  }
}
class UpdateCustomerNotesRequest {
  static fromProto(proto) {
    let m = new UpdateCustomerNotesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customerNotes !== 'undefined') {
      toReturn['customerNotes'] = this.customerNotes;
    }
    return toReturn;
  }
}
class UpdateCustomerRecipientUserIdRequest {
  static fromProto(proto) {
    let m = new UpdateCustomerRecipientUserIdRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.customerRecipientUserId !== 'undefined') {
      toReturn['customerRecipientUserId'] = this.customerRecipientUserId;
    }
    return toReturn;
  }
}
class UpdateEnforceContractTermRequest {
  static fromProto(proto) {
    let m = new UpdateEnforceContractTermRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.enforceContractTerm !== 'undefined') {
      toReturn['enforceContractTerm'] = this.enforceContractTerm;
    }
    return toReturn;
  }
}
class UpdateLineItemsRequest {
  static fromProto(proto) {
    let m = new UpdateLineItemsRequest();
    m = Object.assign(m, proto);
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(LineItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    return toReturn;
  }
}
class UpdateNotesRequest {
  static fromProto(proto) {
    let m = new UpdateNotesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.notes !== 'undefined') {
      toReturn['notes'] = this.notes;
    }
    return toReturn;
  }
}
class UpdatePaymentMethodTokenRequest {
  static fromProto(proto) {
    let m = new UpdatePaymentMethodTokenRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.paymentMethodToken !== 'undefined') {
      toReturn['paymentMethodToken'] = this.paymentMethodToken;
    }
    return toReturn;
  }
}
class UpdateReasonRequest {
  static fromProto(proto) {
    let m = new UpdateReasonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
class UpdateReasonResponse {
  static fromProto(proto) {
    let m = new UpdateReasonResponse();
    m = Object.assign(m, proto);
    if (proto.declinedReason) {
      m.declinedReason = DeclinedReason.fromProto(proto.declinedReason);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.declinedReason !== 'undefined' && this.declinedReason !== null) {
      toReturn['declinedReason'] = 'toApiJson' in this.declinedReason ? this.declinedReason.toApiJson() : this.declinedReason;
    }
    return toReturn;
  }
}
class UpdateRequestedActivationRequest {
  static fromProto(proto) {
    let m = new UpdateRequestedActivationRequest();
    m = Object.assign(m, proto);
    if (proto.requestedActivation) {
      m.requestedActivation = new Date(proto.requestedActivation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.requestedActivation !== 'undefined' && this.requestedActivation !== null) {
      toReturn['requestedActivation'] = 'toApiJson' in this.requestedActivation ? this.requestedActivation.toApiJson() : this.requestedActivation;
    }
    return toReturn;
  }
}
class UpdateSalesOrderMarketRequest {
  static fromProto(proto) {
    let m = new UpdateSalesOrderMarketRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class UpdateSalespersonRequest {
  static fromProto(proto) {
    let m = new UpdateSalespersonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    return toReturn;
  }
}
class UpdateSalespersonResponse {
  static fromProto(proto) {
    let m = new UpdateSalespersonResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class UpdateTagsRequest {
  static fromProto(proto) {
    let m = new UpdateTagsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    return toReturn;
  }
}
class UpdateTagsResponse {
  static fromProto(proto) {
    let m = new UpdateTagsResponse();
    m = Object.assign(m, proto);
    if (proto.order) {
      m.order = Order.fromProto(proto.order);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.order !== 'undefined' && this.order !== null) {
      toReturn['order'] = 'toApiJson' in this.order ? this.order.toApiJson() : this.order;
    }
    return toReturn;
  }
}
class GetUsersResponseUsersEntry {
  static fromProto(proto) {
    let m = new GetUsersResponseUsersEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = User.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class ValidateLineItemsRequest {
  static fromProto(proto) {
    let m = new ValidateLineItemsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    return toReturn;
  }
}
class ValidateLineItemsResponse {
  static fromProto(proto) {
    let m = new ValidateLineItemsResponse();
    m = Object.assign(m, proto);
    if (proto.errorCodes) {
      m.errorCodes = proto.errorCodes.map(v => enumStringToValue$1(ValidationErrorCodes, v));
    }
    if (proto.lineItemErrors) {
      m.lineItemErrors = Object.keys(proto.lineItemErrors).reduce((obj, k) => {
        obj[k] = ValidationErrorList.fromProto(proto.lineItemErrors[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errorCodes !== 'undefined') {
      toReturn['errorCodes'] = this.errorCodes;
    }
    if (typeof this.lineItemErrors !== 'undefined' && this.lineItemErrors !== null) {
      toReturn['lineItemErrors'] = 'toApiJson' in this.lineItemErrors ? this.lineItemErrors.toApiJson() : this.lineItemErrors;
    }
    return toReturn;
  }
}
class VendorOrder {
  static fromProto(proto) {
    let m = new VendorOrder();
    m = Object.assign(m, proto);
    if (proto.business) {
      m.business = Business.fromProto(proto.business);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.pricing) {
      m.pricing = Pricing.fromProto(proto.pricing);
    }
    if (proto.activationStatus) {
      m.activationStatus = enumStringToValue$1(ActivationStatus, proto.activationStatus);
    }
    if (proto.fulfillmentStatus) {
      m.fulfillmentStatus = FulfillmentStatus.fromProto(proto.fulfillmentStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    if (typeof this.resellerId !== 'undefined') {
      toReturn['resellerId'] = this.resellerId;
    }
    if (typeof this.resellerName !== 'undefined') {
      toReturn['resellerName'] = this.resellerName;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.appName !== 'undefined') {
      toReturn['appName'] = this.appName;
    }
    if (typeof this.business !== 'undefined' && this.business !== null) {
      toReturn['business'] = 'toApiJson' in this.business ? this.business.toApiJson() : this.business;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.activationStatus !== 'undefined') {
      toReturn['activationStatus'] = this.activationStatus;
    }
    if (typeof this.fulfillmentStatus !== 'undefined' && this.fulfillmentStatus !== null) {
      toReturn['fulfillmentStatus'] = 'toApiJson' in this.fulfillmentStatus ? this.fulfillmentStatus.toApiJson() : this.fulfillmentStatus;
    }
    if (typeof this.rejectedReason !== 'undefined') {
      toReturn['rejectedReason'] = this.rejectedReason;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArchiveDocumentRequest {
  static fromProto(proto) {
    let m = new ArchiveDocumentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    return toReturn;
  }
}
class Content {
  static fromProto(proto) {
    let m = new Content();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(ContentType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class CreateDocumentRequest {
  static fromProto(proto) {
    let m = new CreateDocumentRequest();
    m = Object.assign(m, proto);
    if (proto.document) {
      m.document = Document.fromProto(proto.document);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.document !== 'undefined' && this.document !== null) {
      toReturn['document'] = 'toApiJson' in this.document ? this.document.toApiJson() : this.document;
    }
    return toReturn;
  }
}
class CreateDocumentResponse {
  static fromProto(proto) {
    let m = new CreateDocumentResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    return toReturn;
  }
}
class DeleteDocumentRequest {
  static fromProto(proto) {
    let m = new DeleteDocumentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    return toReturn;
  }
}
class Document {
  static fromProto(proto) {
    let m = new Document();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.pageCount) {
      m.pageCount = parseInt(proto.pageCount, 10);
    }
    if (proto.type) {
      m.type = enumStringToValue(DocumentType, proto.type);
    }
    if (proto.shareType) {
      m.shareType = enumStringToValue(DocumentShareType, proto.shareType);
    }
    if (proto.organizationType) {
      m.organizationType = enumStringToValue(OrganizationType, proto.organizationType);
    }
    if (proto.recipientOrganizationType) {
      m.recipientOrganizationType = enumStringToValue(OrganizationType, proto.recipientOrganizationType);
    }
    if (proto.status) {
      m.status = enumStringToValue(DocumentStatus, proto.status);
    }
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    if (proto.viewCount) {
      m.viewCount = parseInt(proto.viewCount, 10);
    }
    if (proto.format) {
      m.format = Format.fromProto(proto.format);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.pageCount !== 'undefined') {
      toReturn['pageCount'] = this.pageCount;
    }
    if (typeof this.jsonContent !== 'undefined') {
      toReturn['jsonContent'] = this.jsonContent;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.shareType !== 'undefined') {
      toReturn['shareType'] = this.shareType;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    if (typeof this.organizationType !== 'undefined') {
      toReturn['organizationType'] = this.organizationType;
    }
    if (typeof this.creatorUserId !== 'undefined') {
      toReturn['creatorUserId'] = this.creatorUserId;
    }
    if (typeof this.recipientOrganizationId !== 'undefined') {
      toReturn['recipientOrganizationId'] = this.recipientOrganizationId;
    }
    if (typeof this.recipientOrganizationType !== 'undefined') {
      toReturn['recipientOrganizationType'] = this.recipientOrganizationType;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    if (typeof this.viewCount !== 'undefined') {
      toReturn['viewCount'] = this.viewCount;
    }
    if (typeof this.thumbnailPath !== 'undefined') {
      toReturn['thumbnailPath'] = this.thumbnailPath;
    }
    if (typeof this.pdfPath !== 'undefined') {
      toReturn['pdfPath'] = this.pdfPath;
    }
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.recipientContactId !== 'undefined') {
      toReturn['recipientContactId'] = this.recipientContactId;
    }
    if (typeof this.format !== 'undefined' && this.format !== null) {
      toReturn['format'] = 'toApiJson' in this.format ? this.format.toApiJson() : this.format;
    }
    return toReturn;
  }
}
class DocumentEmailRecipient {
  static fromProto(proto) {
    let m = new DocumentEmailRecipient();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    return toReturn;
  }
}
class DocumentEvent {
  static fromProto(proto) {
    let m = new DocumentEvent();
    m = Object.assign(m, proto);
    if (proto.occurred) {
      m.occurred = new Date(proto.occurred);
    }
    if (proto.eventType) {
      m.eventType = enumStringToValue(DocumentEventType, proto.eventType);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.context) {
      m.context = DocumentEventContext.fromProto(proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.occurred !== 'undefined' && this.occurred !== null) {
      toReturn['occurred'] = 'toApiJson' in this.occurred ? this.occurred.toApiJson() : this.occurred;
    }
    if (typeof this.performedBy !== 'undefined') {
      toReturn['performedBy'] = this.performedBy;
    }
    if (typeof this.eventType !== 'undefined') {
      toReturn['eventType'] = this.eventType;
    }
    if (typeof this.eventContext !== 'undefined') {
      toReturn['eventContext'] = this.eventContext;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.context !== 'undefined' && this.context !== null) {
      toReturn['context'] = 'toApiJson' in this.context ? this.context.toApiJson() : this.context;
    }
    return toReturn;
  }
}
class DocumentEventContext {
  static fromProto(proto) {
    let m = new DocumentEventContext();
    m = Object.assign(m, proto);
    if (proto.sentByEmailContext) {
      m.sentByEmailContext = DocumentEventContextSentByEmail.fromProto(proto.sentByEmailContext);
    }
    if (proto.viewedByRecipientContext) {
      m.viewedByRecipientContext = DocumentEventContextViewedByRecipient.fromProto(proto.viewedByRecipientContext);
    }
    if (proto.approvedByRecipientContext) {
      m.approvedByRecipientContext = DocumentEventContextApprovedByRecipient.fromProto(proto.approvedByRecipientContext);
    }
    if (proto.feedbackFromRecipientContext) {
      m.feedbackFromRecipientContext = DocumentEventContextFeedbackFromRecipient.fromProto(proto.feedbackFromRecipientContext);
    }
    if (proto.commentFromInternalUserContext) {
      m.commentFromInternalUserContext = DocumentEventContextCommentFromInternalUser.fromProto(proto.commentFromInternalUserContext);
    }
    if (proto.sendForInternalReviewContext) {
      m.sendForInternalReviewContext = DocumentEventContextSendForInternalReview.fromProto(proto.sendForInternalReviewContext);
    }
    if (proto.reviewedByInternalUserContext) {
      m.reviewedByInternalUserContext = DocumentEventContextReviewedByInternalUser.fromProto(proto.reviewedByInternalUserContext);
    }
    if (proto.unlockedDocumentContext) {
      m.unlockedDocumentContext = DocumentEventContextUnlockDocument.fromProto(proto.unlockedDocumentContext);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sentByEmailContext !== 'undefined' && this.sentByEmailContext !== null) {
      toReturn['sentByEmailContext'] = 'toApiJson' in this.sentByEmailContext ? this.sentByEmailContext.toApiJson() : this.sentByEmailContext;
    }
    if (typeof this.viewedByRecipientContext !== 'undefined' && this.viewedByRecipientContext !== null) {
      toReturn['viewedByRecipientContext'] = 'toApiJson' in this.viewedByRecipientContext ? this.viewedByRecipientContext.toApiJson() : this.viewedByRecipientContext;
    }
    if (typeof this.approvedByRecipientContext !== 'undefined' && this.approvedByRecipientContext !== null) {
      toReturn['approvedByRecipientContext'] = 'toApiJson' in this.approvedByRecipientContext ? this.approvedByRecipientContext.toApiJson() : this.approvedByRecipientContext;
    }
    if (typeof this.feedbackFromRecipientContext !== 'undefined' && this.feedbackFromRecipientContext !== null) {
      toReturn['feedbackFromRecipientContext'] = 'toApiJson' in this.feedbackFromRecipientContext ? this.feedbackFromRecipientContext.toApiJson() : this.feedbackFromRecipientContext;
    }
    if (typeof this.commentFromInternalUserContext !== 'undefined' && this.commentFromInternalUserContext !== null) {
      toReturn['commentFromInternalUserContext'] = 'toApiJson' in this.commentFromInternalUserContext ? this.commentFromInternalUserContext.toApiJson() : this.commentFromInternalUserContext;
    }
    if (typeof this.sendForInternalReviewContext !== 'undefined' && this.sendForInternalReviewContext !== null) {
      toReturn['sendForInternalReviewContext'] = 'toApiJson' in this.sendForInternalReviewContext ? this.sendForInternalReviewContext.toApiJson() : this.sendForInternalReviewContext;
    }
    if (typeof this.reviewedByInternalUserContext !== 'undefined' && this.reviewedByInternalUserContext !== null) {
      toReturn['reviewedByInternalUserContext'] = 'toApiJson' in this.reviewedByInternalUserContext ? this.reviewedByInternalUserContext.toApiJson() : this.reviewedByInternalUserContext;
    }
    if (typeof this.unlockedDocumentContext !== 'undefined' && this.unlockedDocumentContext !== null) {
      toReturn['unlockedDocumentContext'] = 'toApiJson' in this.unlockedDocumentContext ? this.unlockedDocumentContext.toApiJson() : this.unlockedDocumentContext;
    }
    return toReturn;
  }
}
class DocumentEventContextApprovedByRecipient {
  static fromProto(proto) {
    let m = new DocumentEventContextApprovedByRecipient();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class DocumentEventContextCommentFromInternalUser {
  static fromProto(proto) {
    let m = new DocumentEventContextCommentFromInternalUser();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.conversationOriginLocationExternalId !== 'undefined') {
      toReturn['conversationOriginLocationExternalId'] = this.conversationOriginLocationExternalId;
    }
    return toReturn;
  }
}
class DocumentEventContextFeedbackFromRecipient {
  static fromProto(proto) {
    let m = new DocumentEventContextFeedbackFromRecipient();
    m = Object.assign(m, proto);
    if (proto.recipientOrganizationType) {
      m.recipientOrganizationType = enumStringToValue(OrganizationType, proto.recipientOrganizationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.recipientOrganizationId !== 'undefined') {
      toReturn['recipientOrganizationId'] = this.recipientOrganizationId;
    }
    if (typeof this.recipientOrganizationType !== 'undefined') {
      toReturn['recipientOrganizationType'] = this.recipientOrganizationType;
    }
    if (typeof this.recipientEmail !== 'undefined') {
      toReturn['recipientEmail'] = this.recipientEmail;
    }
    if (typeof this.recipientName !== 'undefined') {
      toReturn['recipientName'] = this.recipientName;
    }
    return toReturn;
  }
}
class DocumentEventContextReviewedByInternalUser {
  static fromProto(proto) {
    let m = new DocumentEventContextReviewedByInternalUser();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reviewerUserId !== 'undefined') {
      toReturn['reviewerUserId'] = this.reviewerUserId;
    }
    if (typeof this.comment !== 'undefined') {
      toReturn['comment'] = this.comment;
    }
    return toReturn;
  }
}
class DocumentEventContextSendForInternalReview {
  static fromProto(proto) {
    let m = new DocumentEventContextSendForInternalReview();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requesterUserId !== 'undefined') {
      toReturn['requesterUserId'] = this.requesterUserId;
    }
    if (typeof this.reviewerUserId !== 'undefined') {
      toReturn['reviewerUserId'] = this.reviewerUserId;
    }
    if (typeof this.comment !== 'undefined') {
      toReturn['comment'] = this.comment;
    }
    return toReturn;
  }
}
class DocumentEventContextSentByEmail {
  static fromProto(proto) {
    let m = new DocumentEventContextSentByEmail();
    m = Object.assign(m, proto);
    if (proto.sentEmails) {
      m.sentEmails = proto.sentEmails.map(SentDocumentEmail.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sentEmails !== 'undefined' && this.sentEmails !== null) {
      toReturn['sentEmails'] = 'toApiJson' in this.sentEmails ? this.sentEmails.toApiJson() : this.sentEmails;
    }
    return toReturn;
  }
}
class DocumentEventContextUnlockDocument {
  static fromProto(proto) {
    let m = new DocumentEventContextUnlockDocument();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class DocumentEventContextViewedByRecipient {
  static fromProto(proto) {
    let m = new DocumentEventContextViewedByRecipient();
    m = Object.assign(m, proto);
    if (proto.recipientOrganizationType) {
      m.recipientOrganizationType = enumStringToValue(OrganizationType, proto.recipientOrganizationType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.recipientOrganizationId !== 'undefined') {
      toReturn['recipientOrganizationId'] = this.recipientOrganizationId;
    }
    if (typeof this.recipientOrganizationType !== 'undefined') {
      toReturn['recipientOrganizationType'] = this.recipientOrganizationType;
    }
    if (typeof this.recipientEmail !== 'undefined') {
      toReturn['recipientEmail'] = this.recipientEmail;
    }
    if (typeof this.recipientName !== 'undefined') {
      toReturn['recipientName'] = this.recipientName;
    }
    return toReturn;
  }
}
class ListDocumentsRequestFilters {
  static fromProto(proto) {
    let m = new ListDocumentsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.types) {
      m.types = proto.types.map(v => enumStringToValue(DocumentType, v));
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(DocumentStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.types !== 'undefined') {
      toReturn['types'] = this.types;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    if (typeof this.recipientOrganizationId !== 'undefined') {
      toReturn['recipientOrganizationId'] = this.recipientOrganizationId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    return toReturn;
  }
}
class ListDocumentEventsRequestFilters {
  static fromProto(proto) {
    let m = new ListDocumentEventsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.eventTypes) {
      m.eventTypes = proto.eventTypes.map(v => enumStringToValue(DocumentEventType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventTypes !== 'undefined') {
      toReturn['eventTypes'] = this.eventTypes;
    }
    return toReturn;
  }
}
class SearchDocumentsRequestFilters {
  static fromProto(proto) {
    let m = new SearchDocumentsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.types) {
      m.types = proto.types.map(v => enumStringToValue(DocumentType, v));
    }
    if (proto.statuses) {
      m.statuses = proto.statuses.map(v => enumStringToValue(DocumentStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.types !== 'undefined') {
      toReturn['types'] = this.types;
    }
    if (typeof this.statuses !== 'undefined') {
      toReturn['statuses'] = this.statuses;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    if (typeof this.recipientOrganizationId !== 'undefined') {
      toReturn['recipientOrganizationId'] = this.recipientOrganizationId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.organizationUserIds !== 'undefined') {
      toReturn['organizationUserIds'] = this.organizationUserIds;
    }
    return toReturn;
  }
}
class Format {
  static fromProto(proto) {
    let m = new Format();
    m = Object.assign(m, proto);
    if (proto.orientation) {
      m.orientation = enumStringToValue(Orientation, proto.orientation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orientation !== 'undefined') {
      toReturn['orientation'] = this.orientation;
    }
    return toReturn;
  }
}
class GenerateDocumentPDFRequest {
  static fromProto(proto) {
    let m = new GenerateDocumentPDFRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    return toReturn;
  }
}
class GetDocumentLineItemsRequest {
  static fromProto(proto) {
    let m = new GetDocumentLineItemsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    return toReturn;
  }
}
class GetDocumentLineItemsResponse {
  static fromProto(proto) {
    let m = new GetDocumentLineItemsResponse();
    m = Object.assign(m, proto);
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(LineItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    return toReturn;
  }
}
class GetDocumentRequest {
  static fromProto(proto) {
    let m = new GetDocumentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    return toReturn;
  }
}
class GetDocumentResponse {
  static fromProto(proto) {
    let m = new GetDocumentResponse();
    m = Object.assign(m, proto);
    if (proto.document) {
      m.document = Document.fromProto(proto.document);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.document !== 'undefined' && this.document !== null) {
      toReturn['document'] = 'toApiJson' in this.document ? this.document.toApiJson() : this.document;
    }
    return toReturn;
  }
}
class GetMultiDocumentsRequest {
  static fromProto(proto) {
    let m = new GetMultiDocumentsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentIds !== 'undefined') {
      toReturn['documentIds'] = this.documentIds;
    }
    return toReturn;
  }
}
class GetMultiDocumentsResponse {
  static fromProto(proto) {
    let m = new GetMultiDocumentsResponse();
    m = Object.assign(m, proto);
    if (proto.documents) {
      m.documents = proto.documents.map(Document.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documents !== 'undefined' && this.documents !== null) {
      toReturn['documents'] = 'toApiJson' in this.documents ? this.documents.toApiJson() : this.documents;
    }
    return toReturn;
  }
}
class GetProposalEmailPreviewRequest {
  static fromProto(proto) {
    let m = new GetProposalEmailPreviewRequest();
    m = Object.assign(m, proto);
    if (proto.proposalEmailDetails) {
      m.proposalEmailDetails = ProposalEmailDetails.fromProto(proto.proposalEmailDetails);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.proposalEmailDetails !== 'undefined' && this.proposalEmailDetails !== null) {
      toReturn['proposalEmailDetails'] = 'toApiJson' in this.proposalEmailDetails ? this.proposalEmailDetails.toApiJson() : this.proposalEmailDetails;
    }
    if (typeof this.senderUserId !== 'undefined') {
      toReturn['senderUserId'] = this.senderUserId;
    }
    return toReturn;
  }
}
class GetProposalEmailPreviewResponse {
  static fromProto(proto) {
    let m = new GetProposalEmailPreviewResponse();
    m = Object.assign(m, proto);
    if (proto.emailPreviewContent) {
      m.emailPreviewContent = Content.fromProto(proto.emailPreviewContent);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailPreviewContent !== 'undefined' && this.emailPreviewContent !== null) {
      toReturn['emailPreviewContent'] = 'toApiJson' in this.emailPreviewContent ? this.emailPreviewContent.toApiJson() : this.emailPreviewContent;
    }
    return toReturn;
  }
}
class ListDocumentEventsRequest {
  static fromProto(proto) {
    let m = new ListDocumentEventsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListDocumentEventsRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListDocumentEventsResponse {
  static fromProto(proto) {
    let m = new ListDocumentEventsResponse();
    m = Object.assign(m, proto);
    if (proto.events) {
      m.events = proto.events.map(DocumentEvent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.events !== 'undefined' && this.events !== null) {
      toReturn['events'] = 'toApiJson' in this.events ? this.events.toApiJson() : this.events;
    }
    return toReturn;
  }
}
class ListDocumentsRequest {
  static fromProto(proto) {
    let m = new ListDocumentsRequest();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedRequestOptions.fromProto(proto.paging);
    }
    if (proto.filters) {
      m.filters = ListDocumentsRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListDocumentsResponse {
  static fromProto(proto) {
    let m = new ListDocumentsResponse();
    m = Object.assign(m, proto);
    if (proto.documents) {
      m.documents = proto.documents.map(Document.fromProto);
    }
    if (proto.paging) {
      m.paging = PagedResponseMetadata.fromProto(proto.paging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documents !== 'undefined' && this.documents !== null) {
      toReturn['documents'] = 'toApiJson' in this.documents ? this.documents.toApiJson() : this.documents;
    }
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    return toReturn;
  }
}
class MarkDocumentAsReviewedRequest {
  static fromProto(proto) {
    let m = new MarkDocumentAsReviewedRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.reviewerUserId !== 'undefined') {
      toReturn['reviewerUserId'] = this.reviewerUserId;
    }
    if (typeof this.comment !== 'undefined') {
      toReturn['comment'] = this.comment;
    }
    return toReturn;
  }
}
class MarkDocumentAsViewedRequest {
  static fromProto(proto) {
    let m = new MarkDocumentAsViewedRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.orderToken !== 'undefined') {
      toReturn['orderToken'] = this.orderToken;
    }
    return toReturn;
  }
}
class ProposalEmailDetails {
  static fromProto(proto) {
    let m = new ProposalEmailDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.emailText !== 'undefined') {
      toReturn['emailText'] = this.emailText;
    }
    if (typeof this.proposalLinkText !== 'undefined') {
      toReturn['proposalLinkText'] = this.proposalLinkText;
    }
    if (typeof this.closingText !== 'undefined') {
      toReturn['closingText'] = this.closingText;
    }
    return toReturn;
  }
}
class ProposalEmailMessage {
  static fromProto(proto) {
    let m = new ProposalEmailMessage();
    m = Object.assign(m, proto);
    if (proto.to) {
      m.to = proto.to.map(Recipient.fromProto);
    }
    if (proto.replyTo) {
      m.replyTo = Recipient.fromProto(proto.replyTo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.to !== 'undefined' && this.to !== null) {
      toReturn['to'] = 'toApiJson' in this.to ? this.to.toApiJson() : this.to;
    }
    if (typeof this.replyTo !== 'undefined' && this.replyTo !== null) {
      toReturn['replyTo'] = 'toApiJson' in this.replyTo ? this.replyTo.toApiJson() : this.replyTo;
    }
    return toReturn;
  }
}
class Recipient {
  static fromProto(proto) {
    let m = new Recipient();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    return toReturn;
  }
}
class SearchDocumentsRequest {
  static fromProto(proto) {
    let m = new SearchDocumentsRequest();
    m = Object.assign(m, proto);
    if (proto.paging) {
      m.paging = PagedRequestOptions.fromProto(proto.paging);
    }
    if (proto.filters) {
      m.filters = SearchDocumentsRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class SearchDocumentsResponse {
  static fromProto(proto) {
    let m = new SearchDocumentsResponse();
    m = Object.assign(m, proto);
    if (proto.documents) {
      m.documents = proto.documents.map(Document.fromProto);
    }
    if (proto.paging) {
      m.paging = PagedResponseMetadata.fromProto(proto.paging);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documents !== 'undefined' && this.documents !== null) {
      toReturn['documents'] = 'toApiJson' in this.documents ? this.documents.toApiJson() : this.documents;
    }
    if (typeof this.paging !== 'undefined' && this.paging !== null) {
      toReturn['paging'] = 'toApiJson' in this.paging ? this.paging.toApiJson() : this.paging;
    }
    return toReturn;
  }
}
class SendDocumentForInternalReviewRequest {
  static fromProto(proto) {
    let m = new SendDocumentForInternalReviewRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.requesterUserId !== 'undefined') {
      toReturn['requesterUserId'] = this.requesterUserId;
    }
    if (typeof this.reviewerUserId !== 'undefined') {
      toReturn['reviewerUserId'] = this.reviewerUserId;
    }
    if (typeof this.comment !== 'undefined') {
      toReturn['comment'] = this.comment;
    }
    return toReturn;
  }
}
class SendProposalRecipientEmailRequest {
  static fromProto(proto) {
    let m = new SendProposalRecipientEmailRequest();
    m = Object.assign(m, proto);
    if (proto.proposalEmailMessage) {
      m.proposalEmailMessage = ProposalEmailMessage.fromProto(proto.proposalEmailMessage);
    }
    if (proto.proposalEmailDetails) {
      m.proposalEmailDetails = ProposalEmailDetails.fromProto(proto.proposalEmailDetails);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.proposalEmailMessage !== 'undefined' && this.proposalEmailMessage !== null) {
      toReturn['proposalEmailMessage'] = 'toApiJson' in this.proposalEmailMessage ? this.proposalEmailMessage.toApiJson() : this.proposalEmailMessage;
    }
    if (typeof this.senderUserId !== 'undefined') {
      toReturn['senderUserId'] = this.senderUserId;
    }
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.organizationId !== 'undefined') {
      toReturn['organizationId'] = this.organizationId;
    }
    if (typeof this.proposalEmailDetails !== 'undefined' && this.proposalEmailDetails !== null) {
      toReturn['proposalEmailDetails'] = 'toApiJson' in this.proposalEmailDetails ? this.proposalEmailDetails.toApiJson() : this.proposalEmailDetails;
    }
    return toReturn;
  }
}
class SentDocumentEmail {
  static fromProto(proto) {
    let m = new SentDocumentEmail();
    m = Object.assign(m, proto);
    if (proto.recipient) {
      m.recipient = DocumentEmailRecipient.fromProto(proto.recipient);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    return toReturn;
  }
}
class UnarchiveDocumentRequest {
  static fromProto(proto) {
    let m = new UnarchiveDocumentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    return toReturn;
  }
}
class UnlockDocumentRequest {
  static fromProto(proto) {
    let m = new UnlockDocumentRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class UpdateDocumentRequest {
  static fromProto(proto) {
    let m = new UpdateDocumentRequest();
    m = Object.assign(m, proto);
    if (proto.document) {
      m.document = Document.fromProto(proto.document);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.document !== 'undefined' && this.document !== null) {
      toReturn['document'] = 'toApiJson' in this.document ? this.document.toApiJson() : this.document;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertDocumentLineItemsRequest {
  static fromProto(proto) {
    let m = new UpsertDocumentLineItemsRequest();
    m = Object.assign(m, proto);
    if (proto.lineItems) {
      m.lineItems = proto.lineItems.map(LineItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.documentId !== 'undefined') {
      toReturn['documentId'] = this.documentId;
    }
    if (typeof this.lineItems !== 'undefined' && this.lineItems !== null) {
      toReturn['lineItems'] = 'toApiJson' in this.lineItems ? this.lineItems.toApiJson() : this.lineItems;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'sales-orders-api.vendasta-local.com',
  'test': '',
  'demo': 'sales-orders-demo.apigateway.co',
  'prod': 'sales-orders-prod.apigateway.co',
  'production': 'sales-orders-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CustomerSalesOrdersApiService = /*#__PURE__*/(() => {
  class CustomerSalesOrdersApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createSalesOrder(r) {
      const request = r.toApiJson ? r : new CustomerCreateSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/CreateSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CustomerCreateSalesOrderResponse.fromProto(resp)));
    }
    approveSalesOrder(r) {
      const request = r.toApiJson ? r : new CustomerApproveSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/ApproveSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CustomerApproveSalesOrderResponse.fromProto(resp)));
    }
    updateAnswers(r) {
      const request = r.toApiJson ? r : new UpdateAnswersRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/UpdateAnswers", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateAnswersResponse.fromProto(resp)));
    }
    getSalesOrder(r) {
      const request = r.toApiJson ? r : new GetSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/GetSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesOrderResponse.fromProto(resp)));
    }
    listSalesOrder(r) {
      const request = r.toApiJson ? r : new ListCustomerSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/ListSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSalesOrderResponse.fromProto(resp)));
    }
    getUsers(r) {
      const request = r.toApiJson ? r : new GetUsersRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/GetUsers", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUsersResponse.fromProto(resp)));
    }
    declineSalesOrder(r) {
      const request = r.toApiJson ? r : new DeclineSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/DeclineSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => DeclineResponse.fromProto(resp)));
    }
    getConfig(r) {
      const request = r.toApiJson ? r : new CustomerGetConfigurationRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/GetConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigurationResponse.fromProto(resp)));
    }
    initiateOrderExport(r) {
      const request = r.toApiJson ? r : new InitiateOrderExportRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/InitiateOrderExport", request.toApiJson(), this.apiOptions()).pipe(map(resp => InitiateOrderExportResponse.fromProto(resp)));
    }
    createForPartnerApproval(r) {
      const request = r.toApiJson ? r : new CreateForPartnerApprovalRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/CreateForPartnerApproval", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateForPartnerApprovalResponse.fromProto(resp)));
    }
    createWithPaymentIntent(r) {
      const request = r.toApiJson ? r : new CreateWithPaymentIntentRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/CreateWithPaymentIntent", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateWithPaymentIntentResponse.fromProto(resp)));
    }
    previewOrderActivations(r) {
      const request = r.toApiJson ? r : new PreviewOrderActivationsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.CustomerSalesOrders/PreviewOrderActivations", request.toApiJson(), this.apiOptions()).pipe(map(resp => PreviewOrderActivationsResponse.fromProto(resp)));
    }
  }
  CustomerSalesOrdersApiService.ɵfac = function CustomerSalesOrdersApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CustomerSalesOrdersApiService)();
  };
  CustomerSalesOrdersApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CustomerSalesOrdersApiService,
    factory: CustomerSalesOrdersApiService.ɵfac,
    providedIn: 'root'
  });
  return CustomerSalesOrdersApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let DeclinedReasonsApiService = /*#__PURE__*/(() => {
  class DeclinedReasonsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createReason(r) {
      const request = r.toApiJson ? r : new CreateReasonRequest(r);
      return this.http.post(this._host + "/salesorders.v1.DeclinedReasons/CreateReason", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateReasonResponse.fromProto(resp)));
    }
    updateReason(r) {
      const request = r.toApiJson ? r : new UpdateReasonRequest(r);
      return this.http.post(this._host + "/salesorders.v1.DeclinedReasons/UpdateReason", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateReasonResponse.fromProto(resp)));
    }
    archiveReason(r) {
      const request = r.toApiJson ? r : new ArchiveReasonRequest(r);
      return this.http.post(this._host + "/salesorders.v1.DeclinedReasons/ArchiveReason", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listReasons(r) {
      const request = r.toApiJson ? r : new ListReasonsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.DeclinedReasons/ListReasons", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListReasonsResponse.fromProto(resp)));
    }
    getReason(r) {
      const request = r.toApiJson ? r : new GetReasonRequest(r);
      return this.http.post(this._host + "/salesorders.v1.DeclinedReasons/GetReason", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReasonResponse.fromProto(resp)));
    }
  }
  DeclinedReasonsApiService.ɵfac = function DeclinedReasonsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DeclinedReasonsApiService)();
  };
  DeclinedReasonsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DeclinedReasonsApiService,
    factory: DeclinedReasonsApiService.ɵfac,
    providedIn: 'root'
  });
  return DeclinedReasonsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let DocumentsApiService = /*#__PURE__*/(() => {
  class DocumentsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createDocument(r) {
      const request = r.toApiJson ? r : new CreateDocumentRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/CreateDocument", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateDocumentResponse.fromProto(resp)));
    }
    updateDocument(r) {
      const request = r.toApiJson ? r : new UpdateDocumentRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/UpdateDocument", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getDocument(r) {
      const request = r.toApiJson ? r : new GetDocumentRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/GetDocument", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDocumentResponse.fromProto(resp)));
    }
    getMultiDocuments(r) {
      const request = r.toApiJson ? r : new GetMultiDocumentsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/GetMultiDocuments", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiDocumentsResponse.fromProto(resp)));
    }
    listDocuments(r) {
      const request = r.toApiJson ? r : new ListDocumentsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/ListDocuments", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDocumentsResponse.fromProto(resp)));
    }
    deleteDocument(r) {
      const request = r.toApiJson ? r : new DeleteDocumentRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/DeleteDocument", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getDocumentLineItems(r) {
      const request = r.toApiJson ? r : new GetDocumentLineItemsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/GetDocumentLineItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDocumentLineItemsResponse.fromProto(resp)));
    }
    upsertDocumentLineItems(r) {
      const request = r.toApiJson ? r : new UpsertDocumentLineItemsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/UpsertDocumentLineItems", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    sendProposalRecipientEmail(r) {
      const request = r.toApiJson ? r : new SendProposalRecipientEmailRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/SendProposalRecipientEmail", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getProposalEmailPreview(r) {
      const request = r.toApiJson ? r : new GetProposalEmailPreviewRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/GetProposalEmailPreview", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetProposalEmailPreviewResponse.fromProto(resp)));
    }
    archiveDocument(r) {
      const request = r.toApiJson ? r : new ArchiveDocumentRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/ArchiveDocument", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    markDocumentAsViewed(r) {
      const request = r.toApiJson ? r : new MarkDocumentAsViewedRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/MarkDocumentAsViewed", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listDocumentEvents(r) {
      const request = r.toApiJson ? r : new ListDocumentEventsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/ListDocumentEvents", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDocumentEventsResponse.fromProto(resp)));
    }
    sendDocumentForInternalReview(r) {
      const request = r.toApiJson ? r : new SendDocumentForInternalReviewRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/SendDocumentForInternalReview", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    markDocumentAsReviewed(r) {
      const request = r.toApiJson ? r : new MarkDocumentAsReviewedRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/MarkDocumentAsReviewed", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unlockDocument(r) {
      const request = r.toApiJson ? r : new UnlockDocumentRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/UnlockDocument", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unarchiveDocument(r) {
      const request = r.toApiJson ? r : new UnarchiveDocumentRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/UnarchiveDocument", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    searchDocuments(r) {
      const request = r.toApiJson ? r : new SearchDocumentsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/SearchDocuments", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchDocumentsResponse.fromProto(resp)));
    }
    generateDocumentPdf(r) {
      const request = r.toApiJson ? r : new GenerateDocumentPDFRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Documents/GenerateDocumentPDF", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  DocumentsApiService.ɵfac = function DocumentsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DocumentsApiService)();
  };
  DocumentsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DocumentsApiService,
    factory: DocumentsApiService.ɵfac,
    providedIn: 'root'
  });
  return DocumentsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let NotificationsApiService = /*#__PURE__*/(() => {
  class NotificationsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    subscribe(r) {
      const request = r.toApiJson ? r : new SubscribeRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Notifications/Subscribe", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unsubscribe(r) {
      const request = r.toApiJson ? r : new UnsubscribeRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Notifications/Unsubscribe", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSubscribedLocations(r) {
      const request = r.toApiJson ? r : new GetSubscribedLocationsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Notifications/GetSubscribedLocations", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSubscribedLocationsResponse.fromProto(resp)));
    }
    getSubscribers(r) {
      const request = r.toApiJson ? r : new GetSubscribersRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Notifications/GetSubscribers", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSubscribersResponse.fromProto(resp)));
    }
  }
  NotificationsApiService.ɵfac = function NotificationsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationsApiService)();
  };
  NotificationsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NotificationsApiService,
    factory: NotificationsApiService.ɵfac,
    providedIn: 'root'
  });
  return NotificationsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PublicApiService = /*#__PURE__*/(() => {
  class PublicApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    approveSalesOrder(r) {
      const request = r.toApiJson ? r : new ApproveRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Public/ApproveSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => ApproveResponse.fromProto(resp)));
    }
    declineSalesOrder(r) {
      const request = r.toApiJson ? r : new DeclineRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Public/DeclineSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => DeclineResponse.fromProto(resp)));
    }
    getSalesOrder(r) {
      const request = r.toApiJson ? r : new GetRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Public/GetSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetResponse.fromProto(resp)));
    }
    updateOrderFormAnswers(r) {
      const request = r.toApiJson ? r : new UpdateOrderFormAnswersRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Public/UpdateOrderFormAnswers", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateOrderFormAnswersResponse.fromProto(resp)));
    }
    getConfig(r) {
      const request = r.toApiJson ? r : new GetConfigurationRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Public/GetConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigurationResponse.fromProto(resp)));
    }
    getOrderRecipientSession(r) {
      const request = r.toApiJson ? r : new GetOrderRecipientSessionRequest(r);
      return this.http.post(this._host + "/salesorders.v1.Public/GetOrderRecipientSession", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOrderRecipientSessionResponse.fromProto(resp)));
    }
  }
  PublicApiService.ɵfac = function PublicApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PublicApiService)();
  };
  PublicApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PublicApiService,
    factory: PublicApiService.ɵfac,
    providedIn: 'root'
  });
  return PublicApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SalesOrdersApiService = /*#__PURE__*/(() => {
  class SalesOrdersApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createSalesOrder(r) {
      const request = r.toApiJson ? r : new CreateSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/CreateSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateSalesOrderResponse.fromProto(resp)));
    }
    customerCreateSalesOrder(r) {
      const request = r.toApiJson ? r : new CustomerCreateSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/CustomerCreateSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CustomerCreateSalesOrderResponse.fromProto(resp)));
    }
    duplicateSalesOrder(r) {
      const request = r.toApiJson ? r : new DuplicateSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/DuplicateSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => DuplicateSalesOrderResponse.fromProto(resp)));
    }
    updateSalesOrderMarket(r) {
      const request = r.toApiJson ? r : new UpdateSalesOrderMarketRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateSalesOrderMarket", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getSalesOrder(r) {
      const request = r.toApiJson ? r : new GetSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/GetSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesOrderResponse.fromProto(resp)));
    }
    getMultiSalesOrder(r) {
      const request = r.toApiJson ? r : new GetMultiSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/GetMultiSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiSalesOrderResponse.fromProto(resp)));
    }
    getSalesOrderByIdempotencyKey(r) {
      const request = r.toApiJson ? r : new GetSalesOrderByIdempotencyKeyRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/GetSalesOrderByIdempotencyKey", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesOrderResponse.fromProto(resp)));
    }
    listSalesOrder(r) {
      const request = r.toApiJson ? r : new ListSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/ListSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSalesOrderResponse.fromProto(resp)));
    }
    approveSalesOrder(r) {
      const request = r.toApiJson ? r : new ApproveSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/ApproveSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => ApproveSalesOrderResponse.fromProto(resp)));
    }
    customerApproveSalesOrder(r) {
      const request = r.toApiJson ? r : new CustomerApproveSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/CustomerApproveSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CustomerApproveSalesOrderResponse.fromProto(resp)));
    }
    declineSalesOrder(r) {
      const request = r.toApiJson ? r : new DeclineSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/DeclineSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => DeclineSalesOrderResponse.fromProto(resp)));
    }
    activateProducts(r) {
      const request = r.toApiJson ? r : new ActivateProductsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/ActivateProducts", request.toApiJson(), this.apiOptions()).pipe(map(resp => ActivateProductsResponse.fromProto(resp)));
    }
    scheduleActivation(r) {
      const request = r.toApiJson ? r : new ScheduleActivationRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/ScheduleActivation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    archiveSalesOrder(r) {
      const request = r.toApiJson ? r : new ArchiveSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/ArchiveSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => ArchiveSalesOrderResponse.fromProto(resp)));
    }
    deleteSalesOrder(r) {
      const request = r.toApiJson ? r : new DeleteSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/DeleteSalesOrder", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    checkSalesOrderExists(r) {
      const request = r.toApiJson ? r : new CheckSalesOrderExistsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/CheckSalesOrderExists", request.toApiJson(), this.apiOptions()).pipe(map(resp => CheckSalesOrderExistsResponse.fromProto(resp)));
    }
    sendForCustomerApproval(r) {
      const request = r.toApiJson ? r : new SendForCustomerApprovalRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/SendForCustomerApproval", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendForCustomerApprovalResponse.fromProto(resp)));
    }
    sendExistingOrderToCustomerForApproval(r) {
      const request = r.toApiJson ? r : new SendExistingOrderToCustomerForApprovalRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/SendExistingOrderToCustomerForApproval", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    chargeOrder(r) {
      const request = r.toApiJson ? r : new ChargeOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/ChargeOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => ChargeOrderResponse.fromProto(resp)));
    }
    getUsers(r) {
      const request = r.toApiJson ? r : new GetUsersRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/GetUsers", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUsersResponse.fromProto(resp)));
    }
    getConfig(r) {
      const request = r.toApiJson ? r : new GetConfigRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/GetConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConfigResponse.fromProto(resp)));
    }
    updateConfig(r) {
      const request = r.toApiJson ? r : new UpdateConfigRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteConfig(r) {
      const request = r.toApiJson ? r : new DeleteConfigRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/DeleteConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateAnswers(r) {
      const request = r.toApiJson ? r : new UpdateAnswersRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateAnswers", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateAnswersResponse.fromProto(resp)));
    }
    updateTags(r) {
      const request = r.toApiJson ? r : new UpdateTagsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateTagsResponse.fromProto(resp)));
    }
    updateSalesperson(r) {
      const request = r.toApiJson ? r : new UpdateSalespersonRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateSalesperson", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateSalespersonResponse.fromProto(resp)));
    }
    updateNotes(r) {
      const request = r.toApiJson ? r : new UpdateNotesRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateNotes", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateRequestedActivation(r) {
      const request = r.toApiJson ? r : new UpdateRequestedActivationRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateRequestedActivation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateContractDuration(r) {
      const request = r.toApiJson ? r : new UpdateContractDurationRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateContractDuration", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateEnforceContractTerm(r) {
      const request = r.toApiJson ? r : new UpdateEnforceContractTermRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateEnforceContractTerm", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateCurrentRevenue(r) {
      const request = r.toApiJson ? r : new UpdateCurrentRevenueRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateCurrentRevenue", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateLineItems(r) {
      const request = r.toApiJson ? r : new UpdateLineItemsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateLineItems", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updatePaymentMethodToken(r) {
      const request = r.toApiJson ? r : new UpdatePaymentMethodTokenRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdatePaymentMethodToken", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateCustomerRecipientUserId(r) {
      const request = r.toApiJson ? r : new UpdateCustomerRecipientUserIdRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateCustomerRecipientUserId", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listTags(r) {
      const request = r.toApiJson ? r : new ListTagsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/ListTags", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListTagsResponse.fromProto(resp)));
    }
    createDraftSalesOrder(r) {
      const request = r.toApiJson ? r : new CreateDraftSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/CreateDraftSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateDraftSalesOrderResponse.fromProto(resp)));
    }
    submitDraftSalesOrder(r) {
      const request = r.toApiJson ? r : new SubmitDraftRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/SubmitDraftSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => SubmitDraftResponse.fromProto(resp)));
    }
    submitDraftForCustomerApproval(r) {
      const request = r.toApiJson ? r : new SubmitDraftForApprovalRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/SubmitDraftForCustomerApproval", request.toApiJson(), this.apiOptions()).pipe(map(resp => SubmitDraftForApprovalResponse.fromProto(resp)));
    }
    ignoreProductActivationError(r) {
      const request = r.toApiJson ? r : new IgnoreProductActivationErrorRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/IgnoreProductActivationError", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    ignoreAllProductActivationErrors(r) {
      const request = r.toApiJson ? r : new IgnoreAllProductActivationErrorsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/IgnoreAllProductActivationErrors", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    cancelOrder(r) {
      const request = r.toApiJson ? r : new CancelOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/CancelOrder", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    requestCancellation(r) {
      const request = r.toApiJson ? r : new RequestCancellationRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/RequestCancellation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    declineCancellation(r) {
      const request = r.toApiJson ? r : new DeclineCancellationRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/DeclineCancellation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    previewOrderActivations(r) {
      const request = r.toApiJson ? r : new PreviewOrderActivationsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/PreviewOrderActivations", request.toApiJson(), this.apiOptions()).pipe(map(resp => PreviewOrderActivationsResponse.fromProto(resp)));
    }
    approveCancellation(r) {
      const request = r.toApiJson ? r : new ApproveCancellationRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/ApproveCancellation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    convertToDraft(r) {
      const request = r.toApiJson ? r : new ConvertToDraftRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/ConvertToDraft", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getStatusCounts(r) {
      const request = r.toApiJson ? r : new GetStatusCountsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/GetStatusCounts", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetStatusCountsResponse.fromProto(resp)));
    }
    createInvoice(r) {
      const request = r.toApiJson ? r : new CreateInvoiceRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/CreateInvoice", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateInvoiceResponse.fromProto(resp)));
    }
    createAndActivateOrder(r) {
      const request = r.toApiJson ? r : new CreateAndActivateOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/CreateAndActivateOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateAndActivateOrderResponse.fromProto(resp)));
    }
    updateCustomerNotes(r) {
      const request = r.toApiJson ? r : new UpdateCustomerNotesRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateCustomerNotes", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateAttachments(r) {
      const request = r.toApiJson ? r : new UpdateAttachmentsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateAttachments", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateCustomerAttachments(r) {
      const request = r.toApiJson ? r : new UpdateCustomerAttachmentsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/UpdateCustomerAttachments", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    leaseSalesOrderToAutomations(r) {
      const request = r.toApiJson ? r : new LeaseSalesOrderToAutomationsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/LeaseSalesOrderToAutomations", request.toApiJson(), this.apiOptions()).pipe(map(resp => LeaseSalesOrderToAutomationsResponse.fromProto(resp)));
    }
    createLeasedToAutomationsSalesOrder(r) {
      const request = r.toApiJson ? r : new CreateLeasedToAutomationsSalesOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/CreateLeasedToAutomationsSalesOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateLeasedToAutomationsSalesOrderResponse.fromProto(resp)));
    }
    getOrderRecipientDetails(r) {
      const request = r.toApiJson ? r : new GetOrderRecipientDetailsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/GetOrderRecipientDetails", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOrderRecipientDetailsResponse.fromProto(resp)));
    }
    validateLineItems(r) {
      const request = r.toApiJson ? r : new ValidateLineItemsRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrders/ValidateLineItems", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateLineItemsResponse.fromProto(resp)));
    }
  }
  SalesOrdersApiService.ɵfac = function SalesOrdersApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesOrdersApiService)();
  };
  SalesOrdersApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesOrdersApiService,
    factory: SalesOrdersApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesOrdersApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SalesOrdersAuxiliaryFieldDataApiService = /*#__PURE__*/(() => {
  class SalesOrdersAuxiliaryFieldDataApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listAuxiliaryData(r) {
      const request = r.toApiJson ? r : new ListSalesOderAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrdersAuxiliaryFieldData/ListAuxiliaryData", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAuxiliaryDataResponse.fromProto(resp)));
    }
    upsertAuxiliaryData(r) {
      const request = r.toApiJson ? r : new UpsertSalesOrderAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrdersAuxiliaryFieldData/UpsertAuxiliaryData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SalesOrdersAuxiliaryFieldDataApiService.ɵfac = function SalesOrdersAuxiliaryFieldDataApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesOrdersAuxiliaryFieldDataApiService)();
  };
  SalesOrdersAuxiliaryFieldDataApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesOrdersAuxiliaryFieldDataApiService,
    factory: SalesOrdersAuxiliaryFieldDataApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesOrdersAuxiliaryFieldDataApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SalesOrdersAuxiliaryFieldSchemaApiService = /*#__PURE__*/(() => {
  class SalesOrdersAuxiliaryFieldSchemaApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new CreateAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrdersAuxiliaryFieldSchema/CreateAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new GetAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrdersAuxiliaryFieldSchema/GetAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    listAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new ListAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrdersAuxiliaryFieldSchema/ListAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    updateAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new UpdateAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrdersAuxiliaryFieldSchema/UpdateAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    archiveAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new ArchiveAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrdersAuxiliaryFieldSchema/ArchiveAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unarchiveAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new UnarchiveAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrdersAuxiliaryFieldSchema/UnarchiveAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMultiAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new GetMultiAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrdersAuxiliaryFieldSchema/GetMultiAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
  }
  SalesOrdersAuxiliaryFieldSchemaApiService.ɵfac = function SalesOrdersAuxiliaryFieldSchemaApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesOrdersAuxiliaryFieldSchemaApiService)();
  };
  SalesOrdersAuxiliaryFieldSchemaApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesOrdersAuxiliaryFieldSchemaApiService,
    factory: SalesOrdersAuxiliaryFieldSchemaApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesOrdersAuxiliaryFieldSchemaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SalesOrdersDevelopmentApiService = /*#__PURE__*/(() => {
  class SalesOrdersDevelopmentApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createArchivedOrder(r) {
      const request = r.toApiJson ? r : new CreateArchivedOrderRequest(r);
      return this.http.post(this._host + "/salesorders.v1.SalesOrdersDevelopment/CreateArchivedOrder", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateArchivedOrderResponse.fromProto(resp)));
    }
  }
  SalesOrdersDevelopmentApiService.ɵfac = function SalesOrdersDevelopmentApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesOrdersDevelopmentApiService)();
  };
  SalesOrdersDevelopmentApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesOrdersDevelopmentApiService,
    factory: SalesOrdersDevelopmentApiService.ɵfac,
    providedIn: 'root'
  });
  return SalesOrdersDevelopmentApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let VendorOrdersApiService = /*#__PURE__*/(() => {
  class VendorOrdersApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listOrders(r) {
      const request = r.toApiJson ? r : new ListOrdersRequest(r);
      return this.http.post(this._host + "/salesorders.v1.VendorOrders/ListOrders", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListOrdersResponse.fromProto(resp)));
    }
  }
  VendorOrdersApiService.ɵfac = function VendorOrdersApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || VendorOrdersApiService)();
  };
  VendorOrdersApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: VendorOrdersApiService,
    factory: VendorOrdersApiService.ɵfac,
    providedIn: 'root'
  });
  return VendorOrdersApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

function fillOutEmptyValues(order) {
  if (!order.statusHistory) {
    order.statusHistory = [];
  }
  if (!order.lineItems) {
    order.lineItems = [];
  }
  if (!order.origin) {
    order.origin = 0;
  }
  return order;
}
function getOfferExpiry(order) {
  if (order.status !== Status.SUBMITTED_FOR_CUSTOMER_APPROVAL) {
    return null;
  }
  return order.offerExpiry;
}
function flattenValidationErrors(response) {
  const lineItemErrors = response?.lineItemErrors || {};
  const flattenedLineItemErrors = Object.keys(lineItemErrors).reduce((acc, key) => {
    acc[key] = lineItemErrors[key].errorCodes;
    return acc;
  }, {});
  return {
    errorCodes: response?.errorCodes || [],
    lineItemErrors: flattenedLineItemErrors
  };
}
class PagedResponse {
  constructor(results, nextCursor, hasMore, totalResults) {
    this.results = results;
    this.nextCursor = nextCursor;
    this.hasMore = hasMore;
    this.totalResults = totalResults;
  }
}
let SalesOrdersService = /*#__PURE__*/(() => {
  class SalesOrdersService {
    constructor(api, hostService) {
      this.api = api;
      this.hostService = hostService;
    }
    /*
        NOTE:
        @deprecated: createOrder instead
    */
    create(salespersonId, partnerId, businessId, marketId, opportunityIds, requestedActivation, notes, packages, products, customFields, commonFields, origin = Origin.SSC, attachments, extraFields, duration, quoteId, tags) {
      const req = new CreateSalesOrderRequest({
        salespersonId: salespersonId,
        partnerId: partnerId,
        businessId: businessId,
        marketId: marketId,
        opportunityIds: opportunityIds,
        requestedActivation: requestedActivation,
        notes: notes,
        packages: packages,
        products: products,
        customFields: customFields,
        commonFields: commonFields,
        origin: origin,
        attachments: attachments,
        extraFields: extraFields,
        contractDuration: duration,
        quoteId: quoteId,
        tags: tags // NOTE: this method is deprecated, see method docstring
      });
      return this.api.createSalesOrder(req).pipe(map(resp => resp.orderId));
    }
    createOrder(o) {
      const req = new CreateSalesOrderRequest({
        salespersonId: o.salespersonId,
        partnerId: o.partnerId,
        businessId: o.businessId,
        marketId: o.marketId,
        opportunityIds: o.opportunityIds,
        requestedActivation: o.requestedActivation,
        notes: o.notes,
        packages: o.packages,
        products: o.products,
        customFields: o.customFields,
        commonFields: o.commonFields,
        origin: o.origin,
        attachments: o.attachments,
        extraFields: o.extraFields,
        lineItems: ensureLineItemValuesAreOneOf$1(o.lineItems),
        contractDuration: o.contractDuration,
        quoteId: o.quoteId,
        tags: o.tags,
        customerNotes: o.customerNotes,
        enforceContractTerm: o.enforceContractTerm
      });
      return this.api.createSalesOrder(req).pipe(map(resp => resp.orderId));
    }
    get(orderId, businessId, projectionFilter) {
      const req = new GetSalesOrderRequest({
        businessId: businessId,
        orderId: orderId,
        projectionFilter: projectionFilter
      });
      return this.api.getSalesOrder(req).pipe(map(resp => fillOutEmptyValues(resp.order)));
    }
    duplicate(orderId, businessId) {
      const req = new DuplicateSalesOrderRequest({
        businessId: businessId,
        orderId: orderId
      });
      return this.api.duplicateSalesOrder(req).pipe(map(resp => resp.orderId));
    }
    list(partnerId, filters, sortOption, cursor, pageSize) {
      const req = new ListSalesOrderRequest({
        partnerId: partnerId,
        filters: filters,
        sortOption: sortOption,
        cursor: cursor,
        pageSize: pageSize
      });
      return this.api.listSalesOrder(req).pipe(map(resp => {
        const results = resp.totalResults || 0;
        return new PagedResponse(resp.orders, resp.nextCursor, resp.hasMore, results);
      }));
    }
    approve(businessId, orderId) {
      const req = new ApproveSalesOrderRequest({
        businessId: businessId,
        orderId: orderId
      });
      return this.api.approveSalesOrder(req).pipe(map(resp => resp.order));
    }
    decline(businessId, orderId, declinedReason, declinedReasonIds) {
      const req = new DeclineSalesOrderRequest({
        businessId: businessId,
        orderId: orderId,
        declinedReason: declinedReason,
        declinedReasonIds: declinedReasonIds
      });
      return this.api.declineSalesOrder(req).pipe(map(resp => resp.order));
    }
    archive(businessId, orderId) {
      const req = new ArchiveSalesOrderRequest({
        businessId: businessId,
        orderId: orderId
      });
      return this.api.archiveSalesOrder(req).pipe(map(resp => resp.order));
    }
    activate(orderId, businessId, customFields, commonFields, extraFields) {
      const req = {
        orderId: orderId,
        businessId: businessId,
        customFields: customFields,
        commonFields: commonFields,
        extraFields: extraFields
      };
      return this.api.activateProducts(req).pipe(map(resp => resp.order));
    }
    check(partnerId, businessId, productId, editionId, statuses) {
      const req = new CheckSalesOrderExistsRequest({
        partnerId: partnerId,
        businessId: businessId,
        productId: productId,
        productEditionId: editionId,
        statuses: statuses || []
      });
      return this.api.checkSalesOrderExists(req).pipe(map(resp => resp.exists));
    }
    getConfig(partnerId, marketId) {
      return this.api.getConfig({
        partnerId: partnerId,
        marketId: marketId
      }).pipe(map(resp => resp.config));
    }
    updateConfig(config) {
      return this.api.updateConfig({
        config: config,
        fieldMask: buildFieldMask(config)
      }).pipe(map(() => true));
    }
    deleteConfig(partnerId, marketId) {
      return this.api.deleteConfig({
        partnerId,
        marketId
      }).pipe(map(() => true));
    }
    createAndSendToCustomer(order, userID, offerExpiry) {
      order.lineItems = ensureLineItemValuesAreOneOf$1(order.lineItems);
      return this.api.sendForCustomerApproval({
        order: order,
        userId: userID,
        offerExpiry: offerExpiry
      }).pipe(map(resp => resp.orderId));
    }
    /*
        @deprecated: Use the CustomerSalesOrderService instead
    */
    customerCreate(order) {
      order.lineItems = ensureLineItemValuesAreOneOf$1(order.lineItems);
      return this.api.customerCreateSalesOrder({
        order: order
      }).pipe(map(resp => resp.orderId));
    }
    createDraft(order) {
      order.lineItems = ensureLineItemValuesAreOneOf$1(order.lineItems);
      return this.api.createDraftSalesOrder({
        order: order
      }).pipe(map(resp => resp.orderId));
    }
    /*
        @deprecated: Use the CustomerSalesOrderService instead
    */
    customerApproveSalesOrder(orderId, businessId, agreements) {
      return this.api.customerApproveSalesOrder({
        orderId: orderId,
        businessId: businessId,
        agreements: agreements
      }).pipe(map(resp => resp.order.orderId));
    }
    getUsers(orderId, businessId) {
      return this.api.getUsers({
        orderId: orderId,
        businessId: businessId
      }).pipe(map(resp => resp.users !== undefined ? resp.users : {}));
    }
    updateAnswers(orderId, businessId, customFields, commonFields, extraFields) {
      return this.api.updateAnswers({
        orderId: orderId,
        businessId: businessId,
        customFields: customFields,
        commonFields: commonFields,
        extraFields: extraFields
      }).pipe(map(resp => resp.order));
    }
    updateTags(orderId, businessId, tags) {
      return this.api.updateTags({
        orderId,
        businessId,
        tags
      }).pipe(map(resp => resp.order));
    }
    updateSalesperson(orderId, businessId, salespersonId) {
      return this.api.updateSalesperson({
        orderId,
        businessId,
        salespersonId
      }).pipe(map(resp => resp.order));
    }
    updateNotes(orderId, businessId, notes) {
      return this.api.updateNotes({
        orderId,
        businessId,
        notes
      }).pipe(map(() => true));
    }
    updateRequestedActivation(orderId, businessId, requestedActivation) {
      return this.api.updateRequestedActivation({
        orderId,
        businessId,
        requestedActivation
      }).pipe(map(() => true));
    }
    updateContractDuration(orderId, businessId, contractDuration) {
      return this.api.updateContractDuration({
        orderId,
        businessId,
        contractDuration
      }).pipe(map(() => true));
    }
    updateEnforceContractTerm(orderId, businessId, enforceContractTerm) {
      return this.api.updateEnforceContractTerm({
        orderId,
        businessId,
        enforceContractTerm
      }).pipe(map(() => true));
    }
    updateCurrentRevenue(orderId, businessId, lineItems) {
      return this.api.updateCurrentRevenue({
        orderId,
        businessId,
        lineItems
      }).pipe(map(() => true));
    }
    updateLineItems(orderId, businessId, lineItems) {
      return this.api.updateLineItems({
        orderId,
        businessId,
        lineItems
      }).pipe(map(() => true));
    }
    listTags(partnerId, filters) {
      return this.api.listTags({
        partnerId: partnerId,
        filters: filters
      }).pipe(map(resp => resp));
    }
    submitDraftSalesOrder(orderId, businessId, customFields, commonFields, extraFields) {
      return this.api.submitDraftSalesOrder({
        orderId: orderId,
        businessId: businessId,
        customFields: customFields,
        commonFields: commonFields,
        extraFields: extraFields
      }).pipe(map(resp => resp.orderId));
    }
    submitDraftForCustomerApproval(orderId, businessId, userId, customFields, commonFields, extraFields, offerExpiry) {
      return this.api.submitDraftForCustomerApproval({
        orderId: orderId,
        businessId: businessId,
        userId: userId,
        customFields: customFields,
        commonFields: commonFields,
        extraFields: extraFields,
        offerExpiry: offerExpiry
      }).pipe(map(resp => resp.orderId));
    }
    sendExistingOrderToCustomerForApproval(orderId, businessId, userId, offerExpiry, orderIsSmbPayable) {
      return this.api.sendExistingOrderToCustomerForApproval({
        orderId: orderId,
        businessId: businessId,
        userId: userId,
        offerExpiry: offerExpiry,
        orderIsSmbPayable: orderIsSmbPayable
      }).pipe(map(() => true));
    }
    chargeOrder(orderId, businessId) {
      return this.api.chargeOrder({
        orderId: orderId,
        businessId: businessId
      }).pipe(map(resp => true));
    }
    ignoreProductActivationError(orderId, businessId, productActivationUniqueId) {
      return this.api.ignoreProductActivationError({
        businessId: businessId,
        orderId: orderId,
        productActivationUniqueId: productActivationUniqueId
      }).pipe(map(resp => true));
    }
    ignoreAllProductActivationErrors(orderId, businessId) {
      return this.api.ignoreAllProductActivationErrors({
        businessId: businessId,
        orderId: orderId
      }).pipe(map(resp => true));
    }
    cancelOrder(orderId, businessId, notes) {
      return this.api.cancelOrder({
        businessId: businessId,
        orderId: orderId,
        notes: notes
      }).pipe(map(() => true));
    }
    requestCancellation(orderId, businessId, notes) {
      return this.api.requestCancellation({
        businessId: businessId,
        orderId: orderId,
        notes: notes
      }).pipe(map(() => true));
    }
    approveCancellation(orderId, businessId) {
      return this.api.approveCancellation({
        businessId: businessId,
        orderId: orderId
      }).pipe(map(() => true));
    }
    declineCancellation(orderId, businessId, notes) {
      return this.api.declineCancellation({
        businessId: businessId,
        orderId: orderId,
        notes: notes
      }).pipe(map(() => true));
    }
    previewOrderActivations(orderId, businessId) {
      return this.api.previewOrderActivations({
        businessId,
        orderId
      }).pipe(map(resp => resp.productActivations));
    }
    scheduleActivation(orderId, businessId, customFields, commonFields, extraFields) {
      return this.api.scheduleActivation({
        businessId,
        orderId,
        customFields,
        commonFields,
        extraFields
      }).pipe(map(() => true));
    }
    convertToDraft(orderId, businessId) {
      return this.api.convertToDraft({
        businessId,
        orderId
      }).pipe(map(() => true));
    }
    getStatusCounts(partnerId, filters) {
      return this.api.getStatusCounts({
        partnerId: partnerId,
        filters: filters
      }).pipe(map(resp => resp.counts));
    }
    createInvoice(orderId, businessId) {
      return this.api.createInvoice({
        orderId: orderId,
        businessId: businessId
      }).pipe(map(resp => resp.invoiceId));
    }
    createAndActivateOrder(order) {
      order.lineItems = ensureLineItemValuesAreOneOf$1(order.lineItems);
      return this.api.createAndActivateOrder({
        order: order
      }).pipe(map(resp => resp.orderId));
    }
    updateCustomerNotes(orderId, businessId, customerNotes) {
      return this.api.updateCustomerNotes({
        orderId,
        businessId,
        customerNotes
      }).pipe(map(() => true));
    }
    updateAttachments(orderId, businessId, attachments) {
      return this.api.updateAttachments({
        orderId,
        businessId,
        attachments
      }).pipe(map(() => true));
    }
    updateCustomerAttachments(orderId, businessId, attachments) {
      return this.api.updateCustomerAttachments({
        orderId,
        businessId,
        attachments
      }).pipe(map(() => true));
    }
    updatePaymentMethodToken(orderId, businessId, paymentMethodToken) {
      return this.api.updatePaymentMethodToken({
        orderId,
        businessId,
        paymentMethodToken
      }).pipe(map(() => true));
    }
    updateCustomerRecipientUserId(orderId, businessId, customerRecipientUserId) {
      return this.api.updateCustomerRecipientUserId({
        orderId,
        businessId,
        customerRecipientUserId
      }).pipe(map(() => true));
    }
    getUploadFileUrl() {
      return `${this.hostService.hostWithScheme}/file/upload`;
    }
    leaseToAutomations(businessId, orderId, customFields, commonFields, extraFields, actionType, declinedReason, declinedReasonIds) {
      const leaseData = {
        actionType: actionType,
        declinedReason: declinedReason,
        declinedReasonIds: declinedReasonIds
      };
      const req = new LeaseSalesOrderToAutomationsRequest({
        businessId: businessId,
        orderId: orderId,
        customFields: customFields,
        commonFields: commonFields,
        extraFields: extraFields,
        leaseData: leaseData
      });
      return this.api.leaseSalesOrderToAutomations(req).pipe(map(resp => resp.order));
    }
    createLeasedToAutomationsSalesOrder(order) {
      order.lineItems = ensureLineItemValuesAreOneOf$1(order.lineItems);
      return this.api.createLeasedToAutomationsSalesOrder({
        order: order
      }).pipe(map(resp => resp.orderId));
    }
    getOrderRecipientDetails(orderToken) {
      return this.api.getOrderRecipientDetails({
        token: orderToken
      });
    }
    validateLineItems(businessId, orderId) {
      const req = new ValidateLineItemsRequest({
        businessId: businessId,
        orderId: orderId
      });
      return this.api.validateLineItems(req).pipe(map(resp => flattenValidationErrors(resp)));
    }
  }
  SalesOrdersService.ɵfac = function SalesOrdersService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesOrdersService)(i0.ɵɵinject(SalesOrdersApiService), i0.ɵɵinject(HostService));
  };
  SalesOrdersService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesOrdersService,
    factory: SalesOrdersService.ɵfac,
    providedIn: 'root'
  });
  return SalesOrdersService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function buildFieldMask(obj) {
  const fieldMaskPaths = [];
  for (const x in obj) {
    if (obj.hasOwnProperty(x) && obj[x] !== undefined) {
      fieldMaskPaths.push(x);
    }
  }
  return new FieldMask({
    paths: fieldMaskPaths
  });
}
function ensureLineItemValuesAreOneOf$1(lineItems) {
  return (lineItems || []).map(li => {
    if (!!li.appKey) {
      delete li.packageId;
    } else {
      delete li.appKey;
    }
    return li;
  });
}
let CustomerSalesOrdersService = /*#__PURE__*/(() => {
  class CustomerSalesOrdersService {
    constructor(api) {
      this.api = api;
    }
    create(order) {
      order.lineItems = ensureLineItemValuesAreOneOf(order.lineItems);
      return this.api.createSalesOrder({
        order: order
      }).pipe(map(resp => resp.orderId));
    }
    createForPartnerApproval(order) {
      order.lineItems = ensureLineItemValuesAreOneOf(order.lineItems);
      return this.api.createForPartnerApproval({
        order
      }).pipe(map(resp => resp.orderId));
    }
    approveSalesOrder(orderId, businessId, agreements, paymentMethodToken) {
      return this.api.approveSalesOrder({
        orderId: orderId,
        businessId: businessId,
        agreements: agreements,
        paymentMethodToken
      }).pipe(map(resp => resp.order.orderId));
    }
    updateAnswers(orderId, businessId, customFields, commonFields, extraFields) {
      return this.api.updateAnswers({
        orderId,
        businessId,
        customFields,
        commonFields,
        extraFields
      }).pipe(map(resp => resp.order.orderId));
    }
    get(orderId, businessId) {
      return this.api.getSalesOrder({
        businessId: businessId,
        orderId: orderId
      }).pipe(map(resp => fillOutEmptyValues(resp.order)));
    }
    list(partnerId, filters, sortOption, cursor, pageSize) {
      const req = new ListCustomerSalesOrderRequest({
        partnerId: partnerId,
        filters: filters,
        sortOption: sortOption,
        cursor: cursor,
        pageSize: pageSize
      });
      return this.api.listSalesOrder(req).pipe(map(resp => {
        const results = resp.totalResults || 0;
        return new PagedResponse(resp.orders, resp.nextCursor, resp.hasMore, results);
      }));
    }
    getUsers(orderId, businessId) {
      return this.api.getUsers({
        orderId: orderId,
        businessId: businessId
      }).pipe(map(resp => resp.users !== undefined ? resp.users : {}));
    }
    initiateOrderExport(exportOrderRequest) {
      return this.api.initiateOrderExport(exportOrderRequest);
    }
    createWithPaymentIntent(order) {
      order.lineItems = ensureLineItemValuesAreOneOf(order.lineItems);
      return this.api.createWithPaymentIntent({
        order: order
      }).pipe(map(resp => resp.orderId));
    }
    declineSalesOrder(businessId, orderId, declinedReason) {
      const req = new DeclineSalesOrderRequest({
        businessId: businessId,
        orderId: orderId,
        declinedReason: declinedReason
      });
      return this.api.declineSalesOrder(req).pipe(map(resp => resp.order));
    }
    getConfig(businessId, orderId) {
      const req = new CustomerGetConfigurationRequest({
        businessId: businessId,
        orderId: orderId
      });
      return this.api.getConfig(req).pipe(map(resp => resp.configuration));
    }
    previewOrderActivations(orderId, businessId) {
      return this.api.previewOrderActivations({
        businessId,
        orderId
      }).pipe(map(resp => resp.productActivations));
    }
  }
  CustomerSalesOrdersService.ɵfac = function CustomerSalesOrdersService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CustomerSalesOrdersService)(i0.ɵɵinject(CustomerSalesOrdersApiService));
  };
  CustomerSalesOrdersService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CustomerSalesOrdersService,
    factory: CustomerSalesOrdersService.ɵfac,
    providedIn: 'root'
  });
  return CustomerSalesOrdersService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function ensureLineItemValuesAreOneOf(lineItems) {
  return (lineItems || []).map(li => {
    if (!!li.appKey) {
      delete li.packageId;
    } else {
      delete li.appKey;
    }
    return li;
  });
}
let VendorOrdersService = /*#__PURE__*/(() => {
  class VendorOrdersService {
    constructor(api) {
      this.api = api;
    }
    list(partnerId, cursor, filters) {
      const request = new ListOrdersRequest({
        partnerId: partnerId,
        cursor: cursor
      });
      if (filters) {
        request.filters = filters;
      }
      return this.api.listOrders(request).pipe(map(resp => {
        return new PagedResponse(resp.orders, resp.nextCursor, resp.hasMore, resp.totalResults);
      }));
    }
  }
  VendorOrdersService.ɵfac = function VendorOrdersService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || VendorOrdersService)(i0.ɵɵinject(VendorOrdersApiService));
  };
  VendorOrdersService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: VendorOrdersService,
    factory: VendorOrdersService.ɵfac,
    providedIn: 'root'
  });
  return VendorOrdersService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SalesOrdersPublicService = /*#__PURE__*/(() => {
  class SalesOrdersPublicService {
    constructor(api) {
      this.api = api;
    }
    approveSalesOrder(orderId, agreements) {
      const req = new ApproveRequest({
        orderId: orderId,
        agreements: agreements
      });
      return this.api.approveSalesOrder(req).pipe(map(resp => resp.order.orderId));
    }
    get(orderId) {
      const req = new GetRequest({
        orderId: orderId
      });
      return this.api.getSalesOrder(req).pipe(map(resp => fillOutEmptyValues(resp.order)));
    }
    updateAnswers(orderId, customFields, commonFields, extraFields) {
      const req = new UpdateOrderFormAnswersRequest({
        orderId: orderId,
        customFields: customFields,
        commonFields: commonFields,
        extraFields: extraFields
      });
      return this.api.updateOrderFormAnswers(req).pipe(map(resp => resp.order.orderId));
    }
    decline(orderId, declinedReason) {
      const req = new DeclineRequest({
        orderId: orderId,
        declinedReason: declinedReason
      });
      return this.api.declineSalesOrder(req).pipe(map(resp => resp.order));
    }
    getConfig(orderId) {
      const req = new GetConfigurationRequest({
        orderId: orderId
      });
      return this.api.getConfig(req).pipe(map(resp => resp.configuration));
    }
    getOrderRecipientSession(token) {
      return this.api.getOrderRecipientSession(new GetOrderRecipientSessionRequest({
        token
      })).pipe(map(resp => resp.session));
    }
  }
  SalesOrdersPublicService.ɵfac = function SalesOrdersPublicService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SalesOrdersPublicService)(i0.ɵɵinject(PublicApiService));
  };
  SalesOrdersPublicService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SalesOrdersPublicService,
    factory: SalesOrdersPublicService.ɵfac,
    providedIn: 'root'
  });
  return SalesOrdersPublicService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotificationsService = /*#__PURE__*/(() => {
  class NotificationsService {
    constructor(api) {
      this.api = api;
    }
    subscribe(businessId, orderId, location) {
      return this.api.subscribe({
        businessId: businessId,
        orderId: orderId,
        location: location
      }).pipe(map(() => true));
    }
    unsubscribe(businessId, orderId, location) {
      return this.api.unsubscribe({
        businessId: businessId,
        orderId: orderId,
        location: location
      }).pipe(map(() => true));
    }
    getSubscribedLocations(businessId, orderId) {
      return this.api.getSubscribedLocations({
        businessId: businessId,
        orderId: orderId
      }).pipe(map(resp => resp.locations));
    }
    getSubscribers(businessId, orderId) {
      return this.api.getSubscribers({
        businessId: businessId,
        orderId: orderId
      }).pipe(map(resp => resp.subscribers));
    }
  }
  NotificationsService.ɵfac = function NotificationsService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NotificationsService)(i0.ɵɵinject(NotificationsApiService));
  };
  NotificationsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NotificationsService,
    factory: NotificationsService.ɵfac,
    providedIn: 'root'
  });
  return NotificationsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function declinedReasonFromApi(r) {
  const zeroDate = new Date('0001-01-01T00:00:00Z').valueOf();
  return {
    id: r.id || '',
    reason: r.reason || '',
    partnerId: r.partnerId || '',
    created: !!r.created && r.created.valueOf() !== zeroDate ? new Date(r.created) : null,
    updated: !!r.updated && r.updated.valueOf() !== zeroDate ? new Date(r.updated) : null,
    archived: !!r.archived && r.archived.valueOf() !== zeroDate ? new Date(r.archived) : null
  };
}
let DeclinedReasonService = /*#__PURE__*/(() => {
  class DeclinedReasonService {
    constructor(apiService) {
      this.apiService = apiService;
    }
    create(partnerId, fields) {
      const request = new CreateReasonRequest({
        partnerId,
        reason: fields.reason
      });
      return this.apiService.createReason(request).pipe(map(resp => declinedReasonFromApi(resp.declinedReason)));
    }
    get(id) {
      const request = new GetReasonRequest({
        id
      });
      return this.apiService.getReason(request).pipe(map(resp => declinedReasonFromApi(resp.declinedReason)));
    }
    update(id, fields) {
      const request = new UpdateReasonRequest({
        id,
        reason: fields.reason
      });
      return this.apiService.updateReason(request).pipe(map(resp => declinedReasonFromApi(resp.declinedReason)));
    }
    archive(id) {
      const request = new ArchiveReasonRequest({
        id
      });
      return this.apiService.archiveReason(request);
    }
    list(partnerId, filters) {
      const req = new ListReasonsRequest({
        partnerId,
        filters
      });
      return this.apiService.listReasons(req).pipe(map(resp => (resp.declinedReasons || []).map(item => declinedReasonFromApi(item))));
    }
  }
  DeclinedReasonService.ɵfac = function DeclinedReasonService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DeclinedReasonService)(i0.ɵɵinject(DeclinedReasonsApiService));
  };
  DeclinedReasonService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DeclinedReasonService,
    factory: DeclinedReasonService.ɵfac,
    providedIn: 'root'
  });
  return DeclinedReasonService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CustomerApprovalEventSending = 'sending';
const CustomerApprovalEventProcessing = 'processing';
const CustomerApprovalEventDelivered = 'delivered';
const CustomerApprovalEventBounced = 'bounced';
const CustomerApprovalEventDropped = 'dropped';
const CustomerApprovalEventUnsubscribed = 'unsubscribed';
const CustomerApprovalEventDeferred = 'deferred';
const CustomerApprovalEventSpamReport = 'spam-report';
const CustomerApprovalEventOpened = 'opened';
const CustomerApprovalEventClicked = 'clicked';
const CustomerApprovalEventUpdatedAnswers = 'updated-answers';
const RequestCancellationEvent = 'cancellation-requested';
const DeclineCancellationEvent = 'cancellation-declined';
const UpdatedTagsEvent = 'updated-tags';
const UpdatedNotesEvent = 'updated-notes';
const UpdatedCustomerNotesEvent = 'updated-customer-notes';
const UpdatedRequestedActivationEvent = 'updated-requested-activation';
const UpdateContractDurationEvent = 'updated-contract-duration';
const UpdateEnforceContractTermEvent = 'updated-enforce-contract-term';
const UpdatedDraftEvent = 'updated-draft';
const UpdatedLineItemsEvent = 'updated-line-items';
const DeclinedEvent = 'order-declined';
const UpdatedSalespersonEvent = 'updated-salesperson';
const UpdatedAttachmentsEvent = 'updated-attachments';
const UpdatedCustomerAttachmentsEvent = 'updated-customer-attachments';
class StatusHistoryEvent {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }
}
class SubmittedForCustomerApprovalSendingMetadataData {}
class SubmittedForCustomerApprovalMetadata {
  constructor(userId, event) {
    this.userId = userId;
    this.event = event;
  }
}
class SubmittedForCustomerApprovalSendingMetadata extends SubmittedForCustomerApprovalMetadata {
  constructor(userId, event, metadata) {
    super(userId, event);
    this.offerExpiry = metadata ? metadata.offerExpiry : undefined;
  }
}
class UpdatedDraftMetadata {
  constructor(userId, event) {
    this.userId = userId;
    this.event = event;
  }
}
/*
    @deprecated: UpdatedLineItemsMetadata instead
*/
class UpdatedPricingMetadata {
  constructor(userId, event) {
    this.userId = userId;
    this.event = event;
  }
}
class UpdatedLineItemsMetadata {
  constructor(userId, event) {
    this.userId = userId;
    this.event = event;
  }
}
class UpdatedTagsMetadata {
  constructor(userId, event, data) {
    this.userId = userId;
    this.event = event;
    this.tags = data.tags;
  }
}
class UpdatedSalespersonMetadata {
  constructor(userId, event, data) {
    this.userId = userId;
    this.event = event;
  }
}
class UpdatedRequestedActivationMetadata {
  constructor(userId, event, data) {
    this.userId = userId;
    this.event = event;
    this.previous = data.previous;
    this.current = data.current;
  }
}
class UpdateContractDurationMetadata {
  constructor(userId, event, data) {
    this.userId = userId;
    this.event = event;
    this.previous = data.previous;
    this.current = data.current;
  }
}
class UpdateEnforceContractTermMetadata {
  constructor(userId, event, data) {
    this.userId = userId;
    this.event = event;
    this.previous = data.previous;
    this.current = data.current;
  }
}
class UpdatedAttachmentsMetadata {
  constructor(userId, event) {
    this.userId = userId;
    this.event = event;
  }
}
class UpdatedCustomerAttachmentsMetadata {
  constructor(userId, event) {
    this.userId = userId;
    this.event = event;
  }
}
/*
    @deprecated: NotesMetadata instead
*/
class RequestCancellationMetadata {
  constructor(userId, event, data) {
    this.userId = userId;
    this.event = event;
    this.previous = data.previous;
    this.current = data.current;
  }
}
class NotesMetadata {
  constructor(userId, event, data) {
    this.userId = userId;
    this.event = event;
    this.previous = data.previous;
    this.current = data.current;
  }
}
class CustomerNotesMetadata extends NotesMetadata {
  constructor(userId, event, data) {
    super(userId, event, data);
  }
}
class DeclinedOrderMetadata {
  constructor(userId, event, data) {
    this.userId = userId;
    this.event = event;
    this.previous = '';
    this.current = data.current;
    this.declinedReasons = data.declined_reasons || [];
    this.chargeFailureCode = data.charge_failure_code || '';
    this.chargeDeclineCode = data.charge_decline_code || '';
  }
}
function customerApprovalEventFromKey(k) {
  switch (k) {
    case CustomerApprovalEventSending:
      return new StatusHistoryEvent(CustomerApprovalEventSending, 'Sending');
    case CustomerApprovalEventProcessing:
      return new StatusHistoryEvent(CustomerApprovalEventProcessing, 'Processing');
    case CustomerApprovalEventDelivered:
      return new StatusHistoryEvent(CustomerApprovalEventDelivered, 'Delivered');
    case CustomerApprovalEventBounced:
      return new StatusHistoryEvent(CustomerApprovalEventBounced, 'Bounced');
    case CustomerApprovalEventDropped:
      return new StatusHistoryEvent(CustomerApprovalEventDropped, 'Dropped');
    case CustomerApprovalEventUnsubscribed:
      return new StatusHistoryEvent(CustomerApprovalEventUnsubscribed, 'Unsubscribed');
    case CustomerApprovalEventDeferred:
      return new StatusHistoryEvent(CustomerApprovalEventDeferred, 'Deferred');
    case CustomerApprovalEventSpamReport:
      return new StatusHistoryEvent(CustomerApprovalEventSpamReport, 'Spam report');
    case CustomerApprovalEventOpened:
      return new StatusHistoryEvent(CustomerApprovalEventOpened, 'Email Opened');
    case CustomerApprovalEventClicked:
      return new StatusHistoryEvent(CustomerApprovalEventClicked, 'Email Clicked');
    case CustomerApprovalEventUpdatedAnswers:
      return new StatusHistoryEvent(CustomerApprovalEventUpdatedAnswers, 'Updated Answers');
    default:
      return new StatusHistoryEvent('', 'Unknown');
  }
}
function getMetadataFromStatusHistoryItem(h) {
  if (!h.metadata) {
    return null;
  }
  let metadata;
  try {
    metadata = JSON.parse(h.metadata);
  } catch {
    return null;
  }
  if (metadata.event === UpdatedTagsEvent) {
    const event = new StatusHistoryEvent(UpdatedTagsEvent, 'Updated Tags');
    return new UpdatedTagsMetadata(metadata.user_id, event, metadata.data);
  }
  if (metadata.event === UpdatedSalespersonEvent) {
    const event = new StatusHistoryEvent(UpdatedSalespersonEvent, 'Updated Salesperson');
    return new UpdatedSalespersonMetadata(metadata.user_id, event, metadata.data);
  }
  if (metadata.event === UpdatedRequestedActivationEvent) {
    const event = new StatusHistoryEvent(UpdatedRequestedActivationEvent, 'Updated Contract Start');
    return new UpdatedRequestedActivationMetadata(metadata.user_id, event, metadata.data);
  }
  if (metadata.event === UpdateContractDurationEvent) {
    const event = new StatusHistoryEvent(UpdateContractDurationEvent, 'Updated Contract Length');
    return new UpdateContractDurationMetadata(metadata.user_id, event, metadata.data);
  }
  if (metadata.event === UpdateEnforceContractTermEvent) {
    const event = new StatusHistoryEvent(UpdateEnforceContractTermEvent, 'Updated Enforce Contract Term');
    return new UpdateEnforceContractTermMetadata(metadata.user_id, event, metadata);
  }
  if (metadata.event === UpdatedAttachmentsEvent) {
    const event = new StatusHistoryEvent(UpdatedAttachmentsEvent, 'Updated Attachments');
    return new UpdatedAttachmentsMetadata(metadata.user_id, event);
  }
  if (metadata.event === UpdatedCustomerAttachmentsEvent) {
    const event = new StatusHistoryEvent(UpdatedCustomerAttachmentsEvent, 'Updated Customer Attachments');
    return new UpdatedCustomerAttachmentsMetadata(metadata.user_id, event);
  }
  if (metadata.event === RequestCancellationEvent) {
    const event = new StatusHistoryEvent(RequestCancellationEvent, 'Cancellation Requested');
    return new NotesMetadata(metadata.user_id, event, metadata.data);
  }
  if (metadata.event === DeclineCancellationEvent) {
    const event = new StatusHistoryEvent(DeclineCancellationEvent, 'Cancellation Declined');
    return new NotesMetadata(metadata.user_id, event, metadata.data);
  }
  if (metadata.event === UpdatedNotesEvent) {
    const event = new StatusHistoryEvent(UpdatedNotesEvent, 'Updated Admin Notes');
    return new NotesMetadata(metadata.user_id, event, metadata.data);
  }
  if (metadata.event === UpdatedCustomerNotesEvent) {
    const event = new StatusHistoryEvent(UpdatedCustomerNotesEvent, 'Updated Customer Notes');
    return new CustomerNotesMetadata(metadata.user_id, event, metadata.data);
  }
  if (metadata.event === UpdatedDraftEvent) {
    const event = new StatusHistoryEvent(UpdatedDraftEvent, 'Updated Draft');
    return new UpdatedDraftMetadata(metadata.user_id, event);
  }
  if (metadata.event === UpdatedLineItemsEvent) {
    const event = new StatusHistoryEvent(UpdatedLineItemsEvent, 'Updated Contents');
    return new UpdatedLineItemsMetadata(metadata.user_id, event);
  }
  if (metadata.event === DeclinedEvent) {
    const event = new StatusHistoryEvent(DeclinedEvent, 'Declined');
    return new DeclinedOrderMetadata(metadata.user_id, event, metadata.data);
  }
  if (h.status !== Status.SUBMITTED_FOR_CUSTOMER_APPROVAL) {
    return null;
  }
  if (metadata.event === CustomerApprovalEventSending) {
    const event = customerApprovalEventFromKey(metadata.event);
    return new SubmittedForCustomerApprovalSendingMetadata(metadata.user_id, event, metadata.data);
  }
  return new SubmittedForCustomerApprovalMetadata(metadata.user_id, customerApprovalEventFromKey(metadata.event));
}

/**
 * Generated bundle index. Do not edit.
 */

export { ActivateProductsResponse, ActivationStatus, AddonActivation, AddonKey, ArchiveDocumentRequest, Attachment, AuxiliaryDataFieldType, BillingPeriod, CommonField, Content, ContentType, Cost, CreateDocumentRequest, CreateDocumentResponse, CreateSalesOrderRequest, Currency, CustomField, CustomPriceMapping, CustomerApprovalEventBounced, CustomerApprovalEventClicked, CustomerApprovalEventDeferred, CustomerApprovalEventDelivered, CustomerApprovalEventDropped, CustomerApprovalEventOpened, CustomerApprovalEventProcessing, CustomerApprovalEventSending, CustomerApprovalEventSpamReport, CustomerApprovalEventUnsubscribed, CustomerApprovalEventUpdatedAnswers, CustomerNotesMetadata, CustomerSalesOrdersService, DeclineCancellationEvent, DeclinedOrderMetadata, DeclinedReasonService, DeleteDocumentRequest, Document, DocumentEmailRecipient, DocumentEvent, DocumentEventContext, DocumentEventContextApprovedByRecipient, DocumentEventContextCommentFromInternalUser, DocumentEventContextFeedbackFromRecipient, DocumentEventContextReviewedByInternalUser, DocumentEventContextSendForInternalReview, DocumentEventContextSentByEmail, DocumentEventContextUnlockDocument, DocumentEventContextViewedByRecipient, DocumentEventType, DocumentShareType, DocumentStatus, DocumentType, DocumentsApiService, DropdownOption, DurationPeriod, Field, FieldType, Format, FulfillmentOrderStatus, GenerateDocumentPDFRequest, GetDocumentLineItemsRequest, GetDocumentLineItemsResponse, GetDocumentRequest, GetDocumentResponse, GetMultiDocumentsRequest, GetMultiDocumentsResponse, GetProposalEmailPreviewRequest, GetProposalEmailPreviewResponse, GetStatusCountsResponse, InitiateOrderExportRequest, InitiateOrderExportRequestDataFormatOption, InitiateOrderExportRequestFilters, InitiateOrderExportRequestSortDirection, InitiateOrderExportRequestSortField, InitiateOrderExportRequestSortOption, LineItem, LineItemAppKey, ListAuxiliaryDataResponse, ListCustomerSalesOrderRequestDateRangeFilter, ListCustomerSalesOrderRequestFilters, ListCustomerSalesOrderRequestSortDirection, ListCustomerSalesOrderRequestSortField, ListCustomerSalesOrderRequestSortOption, ListDocumentEventsRequest, ListDocumentEventsRequestFilters, ListDocumentEventsResponse, ListDocumentsRequest, ListDocumentsRequestFilters, ListDocumentsResponse, ListOrdersRequestFilters, ListSalesOrderRequestDateRangeFilter, ListSalesOrderRequestFilters, ListSalesOrderRequestSortDirection, ListSalesOrderRequestSortField, ListSalesOrderRequestSortOption, ListTagsResponse, MarkDocumentAsReviewedRequest, MarkDocumentAsViewedRequest, NotesMetadata, NotificationsService, Order, OrganizationType, Orientation, Origin, Package, PagedResponse, ProductActivation, ProposalEmailDetails, ProposalEmailMessage, Recipient, RequestCancellationEvent, RequestCancellationMetadata, Revenue, RevenueComponent, RevenuePeriod, SalesOrderAuxiliaryDataObjectID, SalesOrdersAuxiliaryFieldDataApiService, SalesOrdersAuxiliaryFieldSchemaApiService, SalesOrdersPublicService, SalesOrdersService, SearchDocumentsRequest, SearchDocumentsRequestFilters, SearchDocumentsResponse, SendDocumentForInternalReviewRequest, SendProposalRecipientEmailRequest, SentDocumentEmail, Source, Status, StatusHistoryItem, SubmittedForCustomerApprovalMetadata, SubmittedForCustomerApprovalSendingMetadata, SubscriptionLocation, UnarchiveDocumentRequest, UnlockDocumentRequest, UpdateContractDurationEvent, UpdateContractDurationMetadata, UpdateDocumentRequest, UpdateEnforceContractTermEvent, UpdateEnforceContractTermMetadata, UpdatedAttachmentsEvent, UpdatedAttachmentsMetadata, UpdatedCustomerAttachmentsEvent, UpdatedCustomerAttachmentsMetadata, UpdatedCustomerNotesEvent, UpdatedDraftEvent, UpdatedLineItemsEvent, UpdatedLineItemsMetadata, UpdatedNotesEvent, UpdatedPricingMetadata, UpdatedRequestedActivationEvent, UpdatedRequestedActivationMetadata, UpdatedSalespersonEvent, UpdatedSalespersonMetadata, UpdatedTagsEvent, UpdatedTagsMetadata, UpsertDocumentLineItemsRequest, UserRole, ValidationErrorCodes, VendorOrder, VendorOrdersService, enumStringToValue, getMetadataFromStatusHistoryItem, getOfferExpiry };
